export const DictionaryIllustrator_ko_KR = [
    {
        id: 18,
        label: '편집 > 앞에 붙이기',
        placement: 'MenuBar',
        name: '앞에 붙이기',
    },
    {
        id: 19,
        label: '편집 > 뒤에 붙이기',
        placement: 'MenuBar',
        name: '뒤에 붙이기',
    },
    {
        id: 20,
        label: '파일 > 템플릿으로 새로 만들기...',
        placement: 'MenuBar',
        name: '템플릿으로 새로 만들기...',
    },
    {
        id: 22,
        label: '오브젝트 > 변형 > 변형 반복',
        placement: 'MenuBar',
        name: '변형 반복',
    },
    {
        id: 23,
        label: '오브젝트 > 그룹',
        placement: 'MenuBar',
        name: '그룹',
    },
    {
        id: 24,
        label: '오브젝트 > 그룹 풀기',
        placement: 'MenuBar',
        name: '그룹 풀기',
    },
    {
        id: 25,
        label: '오브젝트 > 패스 > 연결...',
        placement: 'MenuBar',
        name: '연결...',
    },
    {
        id: 26,
        label: '오브젝트 > 패스 > 평균점 연결...',
        placement: 'MenuBar',
        name: '평균점 연결...',
    },
    {
        id: 28,
        label: '오브젝트 > 잠금 > 선택물',
        placement: 'MenuBar',
        name: '선택물',
    },
    {
        id: 29,
        label: '오브젝트 > 모든 잠금 풀기',
        placement: 'MenuBar',
        name: '모든 잠금 풀기',
    },
    {
        id: 30,
        label: '보기 > 미리보기',
        placement: 'MenuBar',
        name: '미리보기',
    },
    {
        id: 33,
        label: '보기 > 픽셀 미리보기',
        placement: 'MenuBar',
        name: '픽셀 미리보기',
    },
    {
        id: 34,
        label: '문자 > 영역 문자 옵션...',
        placement: 'MenuBar',
        name: '영역 문자 옵션...',
    },
    {
        id: 35,
        label: '보기 > 창에 대지 맞추기',
        placement: 'MenuBar',
        name: '창에 대지 맞추기',
    },
    {
        id: 36,
        label: '창 > 새 창',
        placement: 'MenuBar',
        name: '새 창',
    },
    {
        id: 37,
        label: '보기 > 눈금자 > 눈금자 표시',
        placement: 'MenuBar',
        name: '눈금자 표시',
    },
    {
        id: 38,
        label: '문자 > 패스 상의 문자 > 3D 리본',
        placement: 'MenuBar',
        name: '3D 리본',
    },
    {
        id: 40,
        label: '문자 > 패스 상의 문자 > 계단 단계',
        placement: 'MenuBar',
        name: '계단 단계',
    },
    {
        id: 42,
        label: '오브젝트 > 정돈 > 맨 앞으로 가져오기',
        placement: 'MenuBar',
        name: '맨 앞으로 가져오기',
    },
    {
        id: 43,
        label: '오브젝트 > 정돈 > 맨 뒤로 보내기',
        placement: 'MenuBar',
        name: '맨 뒤로 보내기',
    },
    {
        id: 48,
        label: '파일 > 템플릿으로 저장...',
        placement: 'MenuBar',
        name: '템플릿으로 저장...',
    },
    {
        id: 50,
        label: '오브젝트 > 숨기기 > 선택물',
        placement: 'MenuBar',
        name: '선택물',
    },
    {
        id: 51,
        label: '오브젝트 > 모두 표시',
        placement: 'MenuBar',
        name: '모두 표시',
    },
    {
        id: 52,
        label: '보기 > 안내선 > 안내선 만들기',
        placement: 'MenuBar',
        name: '안내선 만들기',
    },
    {
        id: 53,
        label: '보기 > 안내선 > 안내선 풀기',
        placement: 'MenuBar',
        name: '안내선 풀기',
    },
    {
        id: 54,
        label: '오브젝트 > 변형 > 이동...',
        placement: 'MenuBar',
        name: '이동...',
    },
    {
        id: 55,
        label: 'Illustrator > 환경 설정 > 특수 문자 안내선...',
        placement: 'MenuBar',
        name: '특수 문자 안내선...',
    },
    {
        id: 56,
        label: '오브젝트 > 컴파운드 패스 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 57,
        label: '오브젝트 > 컴파운드 패스 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 62,
        label: '문자 > 윤곽선 만들기',
        placement: 'MenuBar',
        name: '윤곽선 만들기',
    },
    {
        id: 63,
        label: '보기 > 실제 크기',
        placement: 'MenuBar',
        name: '실제 크기',
    },
    {
        id: 74,
        label: '오브젝트 > 그래프 > 유형...',
        placement: 'MenuBar',
        name: '유형...',
    },
    {
        id: 75,
        label: '오브젝트 > 그래프 > 데이터...',
        placement: 'MenuBar',
        name: '데이터...',
    },
    {
        id: 76,
        label: '오브젝트 > 그래프 > 막대...',
        placement: 'MenuBar',
        name: '막대...',
    },
    {
        id: 77,
        label: '오브젝트 > 그래프 > 디자인...',
        placement: 'MenuBar',
        name: '디자인...',
    },
    {
        id: 78,
        label: '오브젝트 > 그래프 > 보기 자...',
        placement: 'MenuBar',
        name: '보기 자...',
    },
    {
        id: 83,
        label: '문자 > 패스 상의 문자 > 무지개',
        placement: 'MenuBar',
        name: '무지개',
    },
    {
        id: 84,
        label: '파일 > 문서 설정...',
        placement: 'MenuBar',
        name: '문서 설정...',
    },
    {
        id: 85,
        label: '보기 > 타일링 인쇄 숨기기',
        placement: 'MenuBar',
        name: '타일링 인쇄 숨기기',
    },
    {
        id: 86,
        label: '보기 > 대지 숨기기',
        placement: 'MenuBar',
        name: '대지 숨기기',
    },
    {
        id: 87,
        label: '문자 > 영역에 문자 맞추기',
        placement: 'MenuBar',
        name: '영역에 문자 맞추기',
    },
    {
        id: 95,
        label: '파일 > 사본 저장...',
        placement: 'MenuBar',
        name: '사본 저장...',
    },
    {
        id: 98,
        label: 'Illustrator > 환경 설정 > 문자...',
        placement: 'MenuBar',
        name: '문자...',
    },
    {
        id: 99,
        label: 'Illustrator > 환경 설정 > 단위...',
        placement: 'MenuBar',
        name: '단위...',
    },
    {
        id: 100,
        label: '오브젝트 > 정돈 > 앞으로 가져오기',
        placement: 'MenuBar',
        name: '앞으로 가져오기',
    },
    {
        id: 101,
        label: '오브젝트 > 정돈 > 뒤로 보내기',
        placement: 'MenuBar',
        name: '뒤로 보내기',
    },
    {
        id: 109,
        label: '창 > 정돈 > 창 최소화',
        placement: 'MenuBar',
        name: '창 최소화',
    },
    {
        id: 110,
        label: '창 > 정돈 > 모두 앞으로 가져오기',
        placement: 'MenuBar',
        name: '모두 앞으로 가져오기',
    },
    {
        id: 113,
        label: '보기 > 안내선 > 안내선 지우기',
        placement: 'MenuBar',
        name: '안내선 지우기',
    },
    {
        id: 114,
        label: '보기 > 템플릿 표시',
        placement: 'MenuBar',
        name: '템플릿 표시',
    },
    {
        id: 115,
        label: '문자 > 가려진 문자 표시',
        placement: 'MenuBar',
        name: '가려진 문자 표시',
    },
    {
        id: 116,
        label: '문자 > 패스 상의 문자 > 경사',
        placement: 'MenuBar',
        name: '경사',
    },
    {
        id: 117,
        label: '파일 > 모두 닫기',
        placement: 'MenuBar',
        name: '모두 닫기',
    },
    {
        id: 119,
        label: '문자 > 패스 상의 문자 > 중력',
        placement: 'MenuBar',
        name: '중력',
    },
    {
        id: 120,
        label: '오브젝트 > 클리핑 마스크 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 121,
        label: '오브젝트 > 클리핑 마스크 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 123,
        label: '문자 > 패스 상의 문자 > 패스 상의 문자 옵션...',
        placement: 'MenuBar',
        name: '패스 상의 문자 옵션...',
    },
    {
        id: 127,
        label: '오브젝트 > 대지 > 대지로 변환',
        placement: 'MenuBar',
        name: '대지로 변환',
    },
    {
        id: 133,
        label: '문자 > 스레드된 텍스트 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 135,
        label: '보기 > 확대',
        placement: 'MenuBar',
        name: '확대',
    },
    {
        id: 136,
        label: '보기 > 축소',
        placement: 'MenuBar',
        name: '축소',
    },
    {
        id: 139,
        label: '편집 > 색상 설정...',
        placement: 'MenuBar',
        name: '색상 설정...',
    },
    {
        id: 140,
        label: 'Illustrator > 환경 설정 > 하이픈 연결...',
        placement: 'MenuBar',
        name: '하이픈 연결...',
    },
    {
        id: 141,
        label: 'Illustrator > 환경 설정 > 플러그 인과 스크래치 디스크...',
        placement: 'MenuBar',
        name: '플러그 인과 스크래치 디스크...',
    },
    {
        id: 142,
        label: '선택 > 선택 취소',
        placement: 'MenuBar',
        name: '선택 취소',
    },
    {
        id: 143,
        label: '보기 > 중복 인쇄 미리보기',
        placement: 'MenuBar',
        name: '중복 인쇄 미리보기',
    },
    {
        id: 144,
        label: '보기 > 새 보기...',
        placement: 'MenuBar',
        name: '새 보기...',
    },
    {
        id: 145,
        label: '보기 > 보기 편집...',
        placement: 'MenuBar',
        name: '보기 편집...',
    },
    {
        id: 146,
        label: '보기 > 점에 물리기',
        placement: 'MenuBar',
        name: '점에 물리기',
    },
    {
        id: 147,
        label: '보기 > 선택 영역 외곽선  숨기기',
        placement: 'MenuBar',
        name: '선택 영역 외곽선  숨기기',
    },
    {
        id: 148,
        label: '오브젝트 > 모양 확장',
        placement: 'MenuBar',
        name: '모양 확장',
    },
    {
        id: 150,
        label: '보기 > 텍스트 스레드 표시',
        placement: 'MenuBar',
        name: '텍스트 스레드 표시',
    },
    {
        id: 154,
        label: '보기 > 안내선 > 안내선 숨기기',
        placement: 'MenuBar',
        name: '안내선 숨기기',
    },
    {
        id: 155,
        label: '보기 > 안내선 > 안내선 잠그기',
        placement: 'MenuBar',
        name: '안내선 잠그기',
    },
    {
        id: 157,
        label: '문자 > 스레드된 텍스트 > 선택 풀기',
        placement: 'MenuBar',
        name: '선택 풀기',
    },
    {
        id: 158,
        label: '문자 > 스레드된 텍스트 > 스레딩 제거',
        placement: 'MenuBar',
        name: '스레딩 제거',
    },
    {
        id: 159,
        label: '보기 > 격자 표시',
        placement: 'MenuBar',
        name: '격자 표시',
    },
    {
        id: 160,
        label: '보기 > 격자에 물리기',
        placement: 'MenuBar',
        name: '격자에 물리기',
    },
    {
        id: 161,
        label: 'Illustrator > 환경 설정 > 안내선과 격자...',
        placement: 'MenuBar',
        name: '안내선과 격자...',
    },
    {
        id: 162,
        label: '오브젝트 > 변형 > 회전...',
        placement: 'MenuBar',
        name: '회전...',
    },
    {
        id: 163,
        label: '오브젝트 > 변형 > 크기 조절...',
        placement: 'MenuBar',
        name: '크기 조절...',
    },
    {
        id: 164,
        label: '오브젝트 > 변형 > 반사...',
        placement: 'MenuBar',
        name: '반사...',
    },
    {
        id: 165,
        label: '오브젝트 > 변형 > 기울이기...',
        placement: 'MenuBar',
        name: '기울이기...',
    },
    {
        id: 166,
        label: '창 > 정돈 > 겹쳐 놓기',
        placement: 'MenuBar',
        name: '겹쳐 놓기',
    },
    {
        id: 168,
        label: '창 > 정돈 > 나란히 놓기',
        placement: 'MenuBar',
        name: '나란히 놓기',
    },
    {
        id: 202,
        label: '보기 > 보정 색상',
        placement: 'MenuBar',
        name: '보정 색상',
    },
    {
        id: 203,
        label: '편집 > 프로필 할당...',
        placement: 'MenuBar',
        name: '프로필 할당...',
    },
    {
        id: 204,
        label: '도움말 > 자습서...',
        placement: 'MenuBar',
        name: '자습서...',
    },
    {
        id: 223,
        label: '파일 > 문서 색상 모드 > CMYK 색상',
        placement: 'MenuBar',
        name: 'CMYK 색상',
    },
    {
        id: 224,
        label: '파일 > 문서 색상 모드 > RGB 색상',
        placement: 'MenuBar',
        name: 'RGB 색상',
    },
    {
        id: 225,
        label: '보기 > 보정 설정 > 문서 CMYK:',
        placement: 'MenuBar',
        name: '문서 CMYK:',
    },
    {
        id: 226,
        label: '보기 > 보정 설정 > 이전 Macintosh RGB(감마 1.8)',
        placement: 'MenuBar',
        name: '이전 Macintosh RGB(감마 1.8)',
    },
    {
        id: 227,
        label: '보기 > 보정 설정 > 인터넷 표준 RGB(sRGB)',
        placement: 'MenuBar',
        name: '인터넷 표준 RGB(sRGB)',
    },
    {
        id: 228,
        label: '보기 > 보정 설정 > 모니터 RGB',
        placement: 'MenuBar',
        name: '모니터 RGB',
    },
    {
        id: 229,
        label: '문자 > 문자 방향 > 가로',
        placement: 'MenuBar',
        name: '가로',
    },
    {
        id: 230,
        label: '문자 > 문자 방향 > 세로',
        placement: 'MenuBar',
        name: '세로',
    },
    {
        id: 232,
        label: '도움말 > 시스템 정보...',
        placement: 'MenuBar',
        name: '시스템 정보...',
    },
    {
        id: 278,
        label: '문자 > 이전 텍스트 > 모든 이전 텍스트 업데이트',
        placement: 'MenuBar',
        name: '모든 이전 텍스트 업데이트',
    },
    {
        id: 279,
        label: '문자 > 이전 텍스트 > 선택된 이전 텍스트 업데이트',
        placement: 'MenuBar',
        name: '선택된 이전 텍스트 업데이트',
    },
    {
        id: 280,
        label: '문자 > 이전 텍스트 > 사본 숨기기',
        placement: 'MenuBar',
        name: '사본 숨기기',
    },
    {
        id: 281,
        label: '문자 > 이전 텍스트 > 사본 삭제',
        placement: 'MenuBar',
        name: '사본 삭제',
    },
    {
        id: 282,
        label: '문자 > 이전 텍스트 > 사본 선택',
        placement: 'MenuBar',
        name: '사본 선택',
    },
    {
        id: 284,
        label: '보기 > 보정 설정 > 사용자 정의...',
        placement: 'MenuBar',
        name: '사용자 정의...',
    },
    {
        id: 289,
        label: 'Illustrator > 환경 설정 > 선택 및 고정점 표시...',
        placement: 'MenuBar',
        name: '선택 및 고정점 표시...',
    },
    {
        id: 292,
        label: '오브젝트 > 클리핑 마스크 > 내용 편집',
        placement: 'MenuBar',
        name: '내용 편집',
    },
    {
        id: 293,
        label: 'Illustrator > 환경 설정 > 사용자 인터페이스...',
        placement: 'MenuBar',
        name: '사용자 인터페이스...',
    },
    {
        id: 294,
        label: 'Illustrator > 환경 설정 > 분할 영역...',
        placement: 'MenuBar',
        name: '분할 영역...',
    },
    {
        id: 295,
        label: '창 > 응용 프로그램 프레임',
        placement: 'MenuBar',
        name: '응용 프로그램 프레임',
    },
    {
        id: 296,
        label: '보기 > 보정 설정 > 색맹 - 적색맹',
        placement: 'MenuBar',
        name: '색맹 - 적색맹',
    },
    {
        id: 297,
        label: '보기 > 보정 설정 > 색맹 - 녹색맹',
        placement: 'MenuBar',
        name: '색맹 - 녹색맹',
    },
    {
        id: 299,
        label: '보기 > 눈금자 > 비디오 눈금자 표시',
        placement: 'MenuBar',
        name: '비디오 눈금자 표시',
    },
    {
        id: 301,
        label: '창 > 정돈 > 창에서 부동',
        placement: 'MenuBar',
        name: '창에서 부동',
    },
    {
        id: 302,
        label: '창 > 정돈 > 창에서 모두 부동',
        placement: 'MenuBar',
        name: '창에서 모두 부동',
    },
    {
        id: 303,
        label: '창 > 정돈 > 모든 창 통합',
        placement: 'MenuBar',
        name: '모든 창 통합',
    },
    {
        id: 304,
        label: '창 > 응용 프로그램 막대',
        placement: 'MenuBar',
        name: '응용 프로그램 막대',
    },
    {
        id: 310,
        label: '문자 > 패스 상의 문자 > 패스 상의 이전 문자 업데이트',
        placement: 'MenuBar',
        name: '패스 상의 이전 문자 업데이트',
    },
    {
        id: 311,
        label: '보기 > 창에 모두 맞추기',
        placement: 'MenuBar',
        name: '창에 모두 맞추기',
    },
    {
        id: 315,
        label: '편집 > 제자리에 붙이기',
        placement: 'MenuBar',
        name: '제자리에 붙이기',
    },
    {
        id: 316,
        label: '편집 > 모든 대지에 붙이기',
        placement: 'MenuBar',
        name: '모든 대지에 붙이기',
    },
    {
        id: 331,
        label: '문자 > 텍스트 유형 변환',
        placement: 'MenuBar',
        name: '텍스트 유형 변환',
    },
    {
        id: 339,
        label: '편집 > 내 설정 > 설정 내보내기...',
        placement: 'MenuBar',
        name: '설정 내보내기...',
    },
    {
        id: 340,
        label: '편집 > 내 설정 > 설정 가져오기...',
        placement: 'MenuBar',
        name: '설정 가져오기...',
    },
    {
        id: 347,
        label: '보기 > GPU를 사용하여 보기',
        placement: 'MenuBar',
        name: 'GPU를 사용하여 보기',
    },
    {
        id: 351,
        label: '파일 > 선택 항목 내보내기...',
        placement: 'MenuBar',
        name: '선택 항목 내보내기...',
    },
    {
        id: 353,
        label: '보기 > 픽셀에 물리기',
        placement: 'MenuBar',
        name: '픽셀에 물리기',
    },
    {
        id: 354,
        label: '파일 > 내보내기 > 화면에 맞게 내보내기...',
        placement: 'MenuBar',
        name: '화면에 맞게 내보내기...',
    },
    {
        id: 355,
        label: '파일 > 내보내기 > 내보내기 형식...',
        placement: 'MenuBar',
        name: '내보내기 형식...',
    },
    {
        id: 356,
        label: '파일 > 내보내기 > 웹용으로 저장(레거시)...',
        placement: 'MenuBar',
        name: '웹용으로 저장(레거시)...',
    },
    {
        id: 368,
        label: '문자 > 특수 문자 삽입 > 심볼 > 글머리 기호',
        placement: 'MenuBar',
        name: '글머리 기호',
    },
    {
        id: 369,
        label: '문자 > 특수 문자 삽입 > 심볼 > 저작권 심볼',
        placement: 'MenuBar',
        name: '저작권 심볼',
    },
    {
        id: 370,
        label: '문자 > 특수 문자 삽입 > 심볼 > 줄임표',
        placement: 'MenuBar',
        name: '줄임표',
    },
    {
        id: 371,
        label: '문자 > 특수 문자 삽입 > 심볼 > 단락 심볼',
        placement: 'MenuBar',
        name: '단락 심볼',
    },
    {
        id: 372,
        label: '문자 > 특수 문자 삽입 > 심볼 > 등록 상표 심볼',
        placement: 'MenuBar',
        name: '등록 상표 심볼',
    },
    {
        id: 373,
        label: '문자 > 특수 문자 삽입 > 심볼 > 섹션 심볼',
        placement: 'MenuBar',
        name: '섹션 심볼',
    },
    {
        id: 374,
        label: '문자 > 특수 문자 삽입 > 심볼 > 상표 심볼',
        placement: 'MenuBar',
        name: '상표 심볼',
    },
    {
        id: 375,
        label: '문자 > 특수 문자 삽입 > 따옴표 > 왼쪽 큰따옴표',
        placement: 'MenuBar',
        name: '왼쪽 큰따옴표',
    },
    {
        id: 376,
        label: '문자 > 특수 문자 삽입 > 따옴표 > 오른쪽 큰따옴표',
        placement: 'MenuBar',
        name: '오른쪽 큰따옴표',
    },
    {
        id: 377,
        label: '문자 > 특수 문자 삽입 > 따옴표 > 왼쪽 작은따옴표',
        placement: 'MenuBar',
        name: '왼쪽 작은따옴표',
    },
    {
        id: 378,
        label: '문자 > 특수 문자 삽입 > 따옴표 > 오른쪽 작은따옴표',
        placement: 'MenuBar',
        name: '오른쪽 작은따옴표',
    },
    {
        id: 379,
        label: '문자 > 특수 문자 삽입 > 하이픈 및 대시 > 전각 대시',
        placement: 'MenuBar',
        name: '전각 대시',
    },
    {
        id: 380,
        label: '문자 > 특수 문자 삽입 > 하이픈 및 대시 > 반각 대시',
        placement: 'MenuBar',
        name: '반각 대시',
    },
    {
        id: 381,
        label: '문자 > 특수 문자 삽입 > 하이픈 및 대시 > 임의 하이픈',
        placement: 'MenuBar',
        name: '임의 하이픈',
    },
    {
        id: 382,
        label: '문자 > 공백 문자 삽입 > 전각 공백',
        placement: 'MenuBar',
        name: '전각 공백',
    },
    {
        id: 383,
        label: '문자 > 공백 문자 삽입 > 반각 공백',
        placement: 'MenuBar',
        name: '반각 공백',
    },
    {
        id: 384,
        label: '문자 > 공백 문자 삽입 > 점선 공백',
        placement: 'MenuBar',
        name: '점선 공백',
    },
    {
        id: 385,
        label: '문자 > 공백 문자 삽입 > 모자란 공간',
        placement: 'MenuBar',
        name: '모자란 공간',
    },
    {
        id: 386,
        label: '문자 > 줄바꿈 문자 삽입 > 강제 줄바꿈',
        placement: 'MenuBar',
        name: '강제 줄바꿈',
    },
    {
        id: 391,
        label: '문자 > 자리표시자 텍스트로 채우기',
        placement: 'MenuBar',
        name: '자리표시자 텍스트로 채우기',
    },
    {
        id: 393,
        label: '오브젝트 > 에셋으로 내보내기 > 단일 에셋',
        placement: 'MenuBar',
        name: '단일 에셋',
    },
    {
        id: 394,
        label: '오브젝트 > 에셋으로 내보내기 > 여러 에셋',
        placement: 'MenuBar',
        name: '여러 에셋',
    },
    {
        id: 396,
        label: '보기 > 트리밍 보기',
        placement: 'MenuBar',
        name: '트리밍 보기',
    },
    {
        id: 397,
        label: '보기 > 프레젠테이션 모드',
        placement: 'MenuBar',
        name: '프레젠테이션 모드',
    },
    {
        id: 404,
        label: '보기 > 화면 모드 > 표준 화면 모드',
        placement: 'MenuBar',
        name: '표준 화면 모드',
    },
    {
        id: 405,
        label: '보기 > 화면 모드 > 메뉴 막대가 있는 전체 화면 모드',
        placement: 'MenuBar',
        name: '메뉴 막대가 있는 전체 화면 모드',
    },
    {
        id: 406,
        label: '보기 > 화면 모드 > 전체 화면 모드',
        placement: 'MenuBar',
        name: '전체 화면 모드',
    },
    {
        id: 411,
        label: '보기 > 글리프에 물리기',
        placement: 'MenuBar',
        name: '글리프에 물리기',
    },
    {
        id: 415,
        label: '보기 > 선택 항목에 대한 회전 보기',
        placement: 'MenuBar',
        name: '선택 항목에 대한 회전 보기',
    },
    {
        id: 417,
        label: '보기 > 회전 보기 > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: '보기 > 회전 보기 > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: '보기 > 회전 보기 > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: '보기 > 회전 보기 > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: '보기 > 회전 보기 > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: '보기 > 회전 보기 > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: '보기 > 회전 보기 > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: '보기 > 회전 보기 > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: '보기 > 회전 보기 > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: '보기 > 회전 보기 > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: '보기 > 회전 보기 > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: '보기 > 회전 보기 > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: '보기 > 회전 보기 > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: '보기 > 회전 보기 > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: '보기 > 회전 보기 > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: '보기 > 회전 보기 > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: '보기 > 회전 보기 > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: '보기 > 회전 보기 > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: '보기 > 회전 보기 > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: '보기 > 회전 보기 재설정',
        placement: 'MenuBar',
        name: '회전 보기 재설정',
    },
    {
        id: 437,
        label: '편집 > 서식 없이 붙여넣기',
        placement: 'MenuBar',
        name: '서식 없이 붙여넣기',
    },
    {
        id: 438,
        label: '도움말 > 새로운 기능...',
        placement: 'MenuBar',
        name: '새로운 기능...',
    },
    {
        id: 440,
        label: '문자 > 글머리 기호 및 번호 매기기 > 글머리 기호 적용',
        placement: 'MenuBar',
        name: '글머리 기호 적용',
    },
    {
        id: 441,
        label: '문자 > 글머리 기호 및 번호 매기기 > 번호 적용',
        placement: 'MenuBar',
        name: '번호 적용',
    },
    {
        id: 448,
        label: '문자 > 글머리 기호 및 번호 매기기 > 텍스트로 변환',
        placement: 'MenuBar',
        name: '텍스트로 변환',
    },
    {
        id: 456,
        label: '문자 > 재입력',
        placement: 'MenuBar',
        name: '재입력',
    },
    {
        id: 471,
        label: '오브젝트 > 전체 그룹 해제',
        placement: 'MenuBar',
        name: '전체 그룹 해제',
    },
    {
        id: 472,
        label: '문자 > 공백 문자 삽입 > 단어 잘림 방지 공백',
        placement: 'MenuBar',
        name: '단어 잘림 방지 공백',
    },
    {
        id: 1383427079,
        label: '보기 > 눈금자 > 대지 눈금자로 변경',
        placement: 'MenuBar',
        name: '대지 눈금자로 변경',
    },
    {
        id: 1633841013,
        label: 'Illustrator > Illustrator 정보...',
        placement: 'MenuBar',
        name: 'Illustrator 정보...',
    },
    {
        id: 1634233456,
        label: '도움말 > Illustrator 도움말...',
        placement: 'MenuBar',
        name: 'Illustrator 도움말...',
    },
    {
        id: 1634296684,
        label: '파일 > 닫기',
        placement: 'MenuBar',
        name: '닫기',
    },
    {
        id: 1668048225,
        label: '편집 > 지우기',
        placement: 'MenuBar',
        name: '지우기',
    },
    {
        id: 1668247673,
        label: '편집 > 복사',
        placement: 'MenuBar',
        name: '복사',
    },
    {
        id: 1668641824,
        label: '편집 > 오리기',
        placement: 'MenuBar',
        name: '오리기',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Illustrator 숨기기',
        placement: 'MenuBar',
        name: 'Illustrator 숨기기',
    },
    {
        id: 1751737455,
        label: 'Illustrator > 기타 숨기기',
        placement: 'MenuBar',
        name: '기타 숨기기',
    },
    {
        id: 1852143392,
        label: '파일 > 새로 만들기...',
        placement: 'MenuBar',
        name: '새로 만들기...',
    },
    {
        id: 1869636974,
        label: '파일 > 열기...',
        placement: 'MenuBar',
        name: '열기...',
    },
    {
        id: 1885434740,
        label: '편집 > 붙이기',
        placement: 'MenuBar',
        name: '붙이기',
    },
    {
        id: 1886545254,
        label: 'Illustrator > 환경 설정 > 일반...',
        placement: 'MenuBar',
        name: '일반...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Illustrator 종료',
        placement: 'MenuBar',
        name: 'Illustrator 종료',
    },
    {
        id: 1919247471,
        label: '편집 > 재실행',
        placement: 'MenuBar',
        name: '재실행',
    },
    {
        id: 1920365172,
        label: '파일 > 복귀',
        placement: 'MenuBar',
        name: '복귀',
    },
    {
        id: 1934727834,
        label: '선택 > 활성 대지 모두',
        placement: 'MenuBar',
        name: '활성 대지 모두',
    },
    {
        id: 1935764588,
        label: '선택 > 모두',
        placement: 'MenuBar',
        name: '모두',
    },
    {
        id: 1935767141,
        label: '파일 > 저장',
        placement: 'MenuBar',
        name: '저장',
    },
    {
        id: 1936220524,
        label: 'Illustrator > 모두 표시',
        placement: 'MenuBar',
        name: '모두 표시',
    },
    {
        id: 1936292352,
        label: '문자 > 크기 > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: '문자 > 크기 > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: '문자 > 크기 > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: '문자 > 크기 > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: '문자 > 크기 > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: '문자 > 크기 > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: '문자 > 크기 > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: '문자 > 크기 > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: '문자 > 크기 > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: '문자 > 크기 > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: '문자 > 크기 > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: '문자 > 크기 > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: '문자 > 크기 > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: '문자 > 크기 > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: '문자 > 크기 > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: '문자 > 크기 > 기타...',
        placement: 'MenuBar',
        name: '기타...',
    },
    {
        id: 1937138035,
        label: '파일 > 다른 이름으로 저장...',
        placement: 'MenuBar',
        name: '다른 이름으로 저장...',
    },
    {
        id: 1970168943,
        label: '편집 > 실행 취소',
        placement: 'MenuBar',
        name: '실행 취소',
    },
    {
        id: 2164260867,
        label: '도움말 > 내 계정 관리...',
        placement: 'MenuBar',
        name: '내 계정 관리...',
    },
    {
        id: 2164260869,
        label: '도움말 > 업데이트...',
        placement: 'MenuBar',
        name: '업데이트...',
    },
    {
        id: 2164260870,
        label: '효과 > 가장 최근 사용 효과 적용',
        placement: 'MenuBar',
        name: '가장 최근 사용 효과 적용',
    },
    {
        id: 2164260871,
        label: '효과 > 마지막 사용 효과',
        placement: 'MenuBar',
        name: '마지막 사용 효과',
    },
    {
        id: 2164260872,
        label: '파일 > Adobe Stock 검색...',
        placement: 'MenuBar',
        name: 'Adobe Stock 검색...',
    },
    {
        id: 2164260873,
        label: '파일 > 가져오기...',
        placement: 'MenuBar',
        name: '가져오기...',
    },
    {
        id: 2164260874,
        label: '오브젝트 > 패스 > 고정점 제거',
        placement: 'MenuBar',
        name: '고정점 제거',
    },
    {
        id: 2164260877,
        label: '문자 > 합성 글꼴...',
        placement: 'MenuBar',
        name: '합성 글꼴...',
    },
    {
        id: 2164260879,
        label: '도움말 > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260880,
        label: '도움말 > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260882,
        label: '도움말 > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260883,
        label: '도움말 > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260884,
        label: '도움말 > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260885,
        label: '도움말 > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260886,
        label: '도움말 > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260887,
        label: '도움말 > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260889,
        label: '도움말 > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260890,
        label: '도움말 > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260892,
        label: '도움말 > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260893,
        label: '도움말 > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260894,
        label: '도움말 > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260896,
        label: '도움말 > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260897,
        label: '도움말 > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260898,
        label: '도움말 > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260899,
        label: '도움말 > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260900,
        label: '도움말 > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260901,
        label: '도움말 > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260902,
        label: '도움말 > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260903,
        label: '도움말 > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260904,
        label: '도움말 > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260905,
        label: '도움말 > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260906,
        label: '도움말 > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260908,
        label: '도움말 > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260909,
        label: '도움말 > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260910,
        label: '도움말 > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260912,
        label: '창 > 정보',
        placement: 'MenuBar',
        name: '정보',
    },
    {
        id: 2164260914,
        label: '창 > 문자 > 문자',
        placement: 'MenuBar',
        name: '문자',
    },
    {
        id: 2164260915,
        label: '창 > 문자 > 단락',
        placement: 'MenuBar',
        name: '단락',
    },
    {
        id: 2164260916,
        label: '창 > 문자 > 탭',
        placement: 'MenuBar',
        name: '탭',
    },
    {
        id: 2164260917,
        label: '창 > 문자 > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260918,
        label: '문자 > 간격 설정값...',
        placement: 'MenuBar',
        name: '간격 설정값...',
    },
    {
        id: 2164260919,
        label: '효과 > Photoshop 효과',
        placement: 'MenuBar',
        name: 'Photoshop 효과',
    },
    {
        id: 2164260922,
        label: '효과 > 흐림 효과 > 고급 흐림 효과...',
        placement: 'MenuBar',
        name: '고급 흐림 효과...',
    },
    {
        id: 2164260923,
        label: '효과 > 흐림 효과 > 방사형 흐림 효과...',
        placement: 'MenuBar',
        name: '방사형 흐림 효과...',
    },
    {
        id: 2164260925,
        label: '효과 > 픽셀화 > 점묘화...',
        placement: 'MenuBar',
        name: '점묘화...',
    },
    {
        id: 2164260926,
        label: '효과 > 픽셀화 > 메조틴트...',
        placement: 'MenuBar',
        name: '메조틴트...',
    },
    {
        id: 2164260928,
        label: '효과 > 비디오 > 인터레이스 제거...',
        placement: 'MenuBar',
        name: '인터레이스 제거...',
    },
    {
        id: 2164260929,
        label: '효과 > 픽셀화 > 수정화...',
        placement: 'MenuBar',
        name: '수정화...',
    },
    {
        id: 2164260930,
        label: '효과 > 픽셀화 > 색상 하프톤...',
        placement: 'MenuBar',
        name: '색상 하프톤...',
    },
    {
        id: 2164260931,
        label: '효과 > 비디오 > NTSC 색상',
        placement: 'MenuBar',
        name: 'NTSC 색상',
    },
    {
        id: 2164260933,
        label: '효과 > 예술 효과 > 수채화 효과...',
        placement: 'MenuBar',
        name: '수채화 효과...',
    },
    {
        id: 2164260935,
        label: '효과 > 스케치 효과 > 물 종이...',
        placement: 'MenuBar',
        name: '물 종이...',
    },
    {
        id: 2164260936,
        label: '효과 > 예술 효과 > 언더페인팅 효과...',
        placement: 'MenuBar',
        name: '언더페인팅 효과...',
    },
    {
        id: 2164260937,
        label: '효과 > 스케치 효과 > 가장자리 찢기...',
        placement: 'MenuBar',
        name: '가장자리 찢기...',
    },
    {
        id: 2164260939,
        label: '효과 > 텍스처 > 텍스처화...',
        placement: 'MenuBar',
        name: '텍스처화...',
    },
    {
        id: 2164260941,
        label: '효과 > 브러시 획 > 수묵화...',
        placement: 'MenuBar',
        name: '수묵화...',
    },
    {
        id: 2164260942,
        label: '효과 > 스케치 효과 > 도장...',
        placement: 'MenuBar',
        name: '도장...',
    },
    {
        id: 2164260943,
        label: '효과 > 텍스처 > 채색 유리...',
        placement: 'MenuBar',
        name: '채색 유리...',
    },
    {
        id: 2164260944,
        label: '효과 > 브러시 획 > 스프레이 획...',
        placement: 'MenuBar',
        name: '스프레이 획...',
    },
    {
        id: 2164260945,
        label: '효과 > 예술 효과 > 스폰지...',
        placement: 'MenuBar',
        name: '스폰지...',
    },
    {
        id: 2164260946,
        label: '효과 > 브러시 획 > 뿌리기...',
        placement: 'MenuBar',
        name: '뿌리기...',
    },
    {
        id: 2164260947,
        label: '효과 > 예술 효과 > 문지르기 효과...',
        placement: 'MenuBar',
        name: '문지르기 효과...',
    },
    {
        id: 2164260948,
        label: '효과 > 예술 효과 > 거친 파스텔 효과...',
        placement: 'MenuBar',
        name: '거친 파스텔 효과...',
    },
    {
        id: 2164260949,
        label: '효과 > 스케치 효과 > 망사 효과...',
        placement: 'MenuBar',
        name: '망사 효과...',
    },
    {
        id: 2164260950,
        label: '효과 > 예술 효과 > 포스터 가장자리...',
        placement: 'MenuBar',
        name: '포스터 가장자리...',
    },
    {
        id: 2164260951,
        label: '효과 > 예술 효과 > 비닐랩...',
        placement: 'MenuBar',
        name: '비닐랩...',
    },
    {
        id: 2164260952,
        label: '효과 > 스케치 효과 > 석고...',
        placement: 'MenuBar',
        name: '석고...',
    },
    {
        id: 2164260953,
        label: '효과 > 스케치 효과 > 복사...',
        placement: 'MenuBar',
        name: '복사...',
    },
    {
        id: 2164260954,
        label: '효과 > 텍스처 > 이어붙이기...',
        placement: 'MenuBar',
        name: '이어붙이기...',
    },
    {
        id: 2164260955,
        label: '효과 > 예술 효과 > 팔레트 나이프...',
        placement: 'MenuBar',
        name: '팔레트 나이프...',
    },
    {
        id: 2164260956,
        label: '효과 > 예술 효과 > 페인트 바르기...',
        placement: 'MenuBar',
        name: '페인트 바르기...',
    },
    {
        id: 2164260958,
        label: '효과 > 왜곡 > 바다 물결...',
        placement: 'MenuBar',
        name: '바다 물결...',
    },
    {
        id: 2164260959,
        label: '효과 > 스케치 효과 > 메모지...',
        placement: 'MenuBar',
        name: '메모지...',
    },
    {
        id: 2164260960,
        label: '효과 > 예술 효과 > 네온광...',
        placement: 'MenuBar',
        name: '네온광...',
    },
    {
        id: 2164260961,
        label: '효과 > 텍스처 > 모자이크 타일...',
        placement: 'MenuBar',
        name: '모자이크 타일...',
    },
    {
        id: 2164260962,
        label: '효과 > 브러시 획 > 잉크 윤곽선...',
        placement: 'MenuBar',
        name: '잉크 윤곽선...',
    },
    {
        id: 2164260963,
        label: '효과 > 스케치 효과 > 하프톤 패턴...',
        placement: 'MenuBar',
        name: '하프톤 패턴...',
    },
    {
        id: 2164260964,
        label: '효과 > 스케치 효과 > 그래픽 펜...',
        placement: 'MenuBar',
        name: '그래픽 펜...',
    },
    {
        id: 2164260965,
        label: '효과 > 텍스처 > 그레인...',
        placement: 'MenuBar',
        name: '그레인...',
    },
    {
        id: 2164260967,
        label: '효과 > 스타일화 > 가장자리 광선 효과...',
        placement: 'MenuBar',
        name: '가장자리 광선 효과...',
    },
    {
        id: 2164260968,
        label: '효과 > 왜곡 > 유리...',
        placement: 'MenuBar',
        name: '유리...',
    },
    {
        id: 2164260969,
        label: '효과 > 예술 효과 > 프레스코...',
        placement: 'MenuBar',
        name: '프레스코...',
    },
    {
        id: 2164260970,
        label: '효과 > 예술 효과 > 필름 그레인...',
        placement: 'MenuBar',
        name: '필름 그레인...',
    },
    {
        id: 2164260971,
        label: '효과 > 예술 효과 > 드라이 브러시...',
        placement: 'MenuBar',
        name: '드라이 브러시...',
    },
    {
        id: 2164260972,
        label: '효과 > 왜곡 > 광선 확산...',
        placement: 'MenuBar',
        name: '광선 확산...',
    },
    {
        id: 2164260973,
        label: '효과 > 브러시 획 > 어두운 획...',
        placement: 'MenuBar',
        name: '어두운 획...',
    },
    {
        id: 2164260974,
        label: '효과 > 예술 효과 > 오려내기...',
        placement: 'MenuBar',
        name: '오려내기...',
    },
    {
        id: 2164260975,
        label: '효과 > 브러시 획 > 그물눈...',
        placement: 'MenuBar',
        name: '그물눈...',
    },
    {
        id: 2164260976,
        label: '효과 > 텍스처 > 균열...',
        placement: 'MenuBar',
        name: '균열...',
    },
    {
        id: 2164260977,
        label: '효과 > 스케치 효과 > 크레용...',
        placement: 'MenuBar',
        name: '크레용...',
    },
    {
        id: 2164260978,
        label: '효과 > 예술 효과 > 색연필...',
        placement: 'MenuBar',
        name: '색연필...',
    },
    {
        id: 2164260979,
        label: '효과 > 스케치 효과 > 크롬...',
        placement: 'MenuBar',
        name: '크롬...',
    },
    {
        id: 2164260980,
        label: '효과 > 스케치 효과 > 목탄...',
        placement: 'MenuBar',
        name: '목탄...',
    },
    {
        id: 2164260981,
        label: '효과 > 스케치 효과 > 분필과 목탄...',
        placement: 'MenuBar',
        name: '분필과 목탄...',
    },
    {
        id: 2164260982,
        label: '효과 > 스케치 효과 > 저부조...',
        placement: 'MenuBar',
        name: '저부조...',
    },
    {
        id: 2164260983,
        label: '효과 > 브러시 획 > 각진 획...',
        placement: 'MenuBar',
        name: '각진 획...',
    },
    {
        id: 2164260984,
        label: '효과 > 브러시 획 > 강조된 가장자리...',
        placement: 'MenuBar',
        name: '강조된 가장자리...',
    },
    {
        id: 2164260985,
        label: '효과 > 효과 갤러리...',
        placement: 'MenuBar',
        name: '효과 갤러리...',
    },
    {
        id: 2164260986,
        label: '편집 > 사용자 정의 사전 편집...',
        placement: 'MenuBar',
        name: '사용자 정의 사전 편집...',
    },
    {
        id: 2164260989,
        label: '오브젝트 > 패스 > 격자로 나누기...',
        placement: 'MenuBar',
        name: '격자로 나누기...',
    },
    {
        id: 2164260991,
        label: '문자 > 대/소문자 변경 > 대문자',
        placement: 'MenuBar',
        name: '대문자',
    },
    {
        id: 2164260992,
        label: '문자 > 대/소문자 변경 > 소문자',
        placement: 'MenuBar',
        name: '소문자',
    },
    {
        id: 2164260993,
        label: '문자 > 대/소문자 변경 > 단어의 첫 글자를 대문자로',
        placement: 'MenuBar',
        name: '단어의 첫 글자를 대문자로',
    },
    {
        id: 2164260994,
        label: '문자 > 대/소문자 변경 > 문장의 첫 글자를 대문자로',
        placement: 'MenuBar',
        name: '문장의 첫 글자를 대문자로',
    },
    {
        id: 2164260995,
        label: '문자 > 시각적 여백 정렬',
        placement: 'MenuBar',
        name: '시각적 여백 정렬',
    },
    {
        id: 2164260996,
        label: '문자 > 글꼴 찾기/바꾸기...',
        placement: 'MenuBar',
        name: '글꼴 찾기/바꾸기...',
    },
    {
        id: 2164260997,
        label: '문자 > 특수 문자 처리...',
        placement: 'MenuBar',
        name: '특수 문자 처리...',
    },
    {
        id: 2164260998,
        label: '효과 > Illustrator 효과',
        placement: 'MenuBar',
        name: 'Illustrator 효과',
    },
    {
        id: 2164261001,
        label: '효과 > 왜곡과 변형 > 변형...',
        placement: 'MenuBar',
        name: '변형...',
    },
    {
        id: 2164261002,
        label: '오브젝트 > 변형 > 개별 변형...',
        placement: 'MenuBar',
        name: '개별 변형...',
    },
    {
        id: 2164261004,
        label: '창 > 라이브러리',
        placement: 'MenuBar',
        name: '라이브러리',
    },
    {
        id: 2164261006,
        label: '창 > Exchange에서 확장 프로그램 찾기...',
        placement: 'MenuBar',
        name: 'Exchange에서 확장 프로그램 찾기...',
    },
    {
        id: 2164261007,
        label: '오브젝트 > 그라디언트 망 만들기...',
        placement: 'MenuBar',
        name: '그라디언트 망 만들기...',
    },
    {
        id: 2164261008,
        label: '창 > 분판 미리보기',
        placement: 'MenuBar',
        name: '분판 미리보기',
    },
    {
        id: 2164261009,
        label: '창 > 연결',
        placement: 'MenuBar',
        name: '연결',
    },
    {
        id: 2164261011,
        label: '편집 > 원본 편집',
        placement: 'MenuBar',
        name: '원본 편집',
    },
    {
        id: 2164261013,
        label: '창 > 문자 > 단락 스타일',
        placement: 'MenuBar',
        name: '단락 스타일',
    },
    {
        id: 2164261014,
        label: '창 > 문자 > 문자 스타일',
        placement: 'MenuBar',
        name: '문자 스타일',
    },
    {
        id: 2164261015,
        label: '창 > 대지',
        placement: 'MenuBar',
        name: '대지',
    },
    {
        id: 2164261017,
        label: '오브젝트 > 대지 > 모든 대지 재정돈',
        placement: 'MenuBar',
        name: '모든 대지 재정돈',
    },
    {
        id: 2164261019,
        label: '오브젝트 > 대지 > 아트웍 테두리에 맞추기',
        placement: 'MenuBar',
        name: '아트웍 테두리에 맞추기',
    },
    {
        id: 2164261020,
        label: '오브젝트 > 대지 > 선택한 아트에 맞추기',
        placement: 'MenuBar',
        name: '선택한 아트에 맞추기',
    },
    {
        id: 2164261021,
        label: '창 > 속성',
        placement: 'MenuBar',
        name: '속성',
    },
    {
        id: 2164261022,
        label: '창 > 내비게이터',
        placement: 'MenuBar',
        name: '내비게이터',
    },
    {
        id: 2164261025,
        label: '창 > 작업 영역 > Getting Started 재설정',
        placement: 'MenuBar',
        name: 'Getting Started 재설정',
    },
    {
        id: 2164261026,
        label: '창 > 작업 영역 > 새 작업 영역...',
        placement: 'MenuBar',
        name: '새 작업 영역...',
    },
    {
        id: 2164261027,
        label: '창 > 작업 영역 > 작업 영역 관리...',
        placement: 'MenuBar',
        name: '작업 영역 관리...',
    },
    {
        id: 2164261028,
        label: '창 > 작업 영역 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261029,
        label: '창 > 작업 영역 > 인쇄 및 보정',
        placement: 'MenuBar',
        name: '인쇄 및 보정',
    },
    {
        id: 2164261030,
        label: '창 > 작업 영역 > 추적',
        placement: 'MenuBar',
        name: '추적',
    },
    {
        id: 2164261031,
        label: '창 > 작업 영역 > 문자 처리',
        placement: 'MenuBar',
        name: '문자 처리',
    },
    {
        id: 2164261032,
        label: '창 > 작업 영역 > 레이아웃',
        placement: 'MenuBar',
        name: '레이아웃',
    },
    {
        id: 2164261033,
        label: '창 > 작업 영역 > 웹',
        placement: 'MenuBar',
        name: '웹',
    },
    {
        id: 2164261034,
        label: '창 > 작업 영역 > 자동화',
        placement: 'MenuBar',
        name: '자동화',
    },
    {
        id: 2164261035,
        label: '창 > 작업 영역 > 필수',
        placement: 'MenuBar',
        name: '필수',
    },
    {
        id: 2164261036,
        label: '창 > 작업 영역 > 페인팅',
        placement: 'MenuBar',
        name: '페인팅',
    },
    {
        id: 2164261037,
        label: '창 > 작업 영역 > 필수 클래식',
        placement: 'MenuBar',
        name: '필수 클래식',
    },
    {
        id: 2164261038,
        label: '문자 > 금칙 처리 설정값...',
        placement: 'MenuBar',
        name: '금칙 처리 설정값...',
    },
    {
        id: 2164261039,
        label: '편집 > 키보드 단축키...',
        placement: 'MenuBar',
        name: '키보드 단축키...',
    },
    {
        id: 2164261040,
        label: '창 > 그래픽 스타일',
        placement: 'MenuBar',
        name: '그래픽 스타일',
    },
    {
        id: 2164261041,
        label: '창 > 모양',
        placement: 'MenuBar',
        name: '모양',
    },
    {
        id: 2164261047,
        label: '창 > 그래픽 스타일 라이브러리 > 3D 효과',
        placement: 'MenuBar',
        name: '3D 효과',
    },
    {
        id: 2164261048,
        label: '창 > 그래픽 스타일 라이브러리 > 가색',
        placement: 'MenuBar',
        name: '가색',
    },
    {
        id: 2164261049,
        label: '창 > 그래픽 스타일 라이브러리 > 네온 효과',
        placement: 'MenuBar',
        name: '네온 효과',
    },
    {
        id: 2164261050,
        label: '창 > 그래픽 스타일 라이브러리 > 단추 및 롤오버',
        placement: 'MenuBar',
        name: '단추 및 롤오버',
    },
    {
        id: 2164261051,
        label: '창 > 그래픽 스타일 라이브러리 > 물방울 브러쉬 가색',
        placement: 'MenuBar',
        name: '물방울 브러쉬 가색',
    },
    {
        id: 2164261052,
        label: '창 > 그래픽 스타일 라이브러리 > 본스터 패턴 스타일',
        placement: 'MenuBar',
        name: '본스터 패턴 스타일',
    },
    {
        id: 2164261053,
        label: '창 > 그래픽 스타일 라이브러리 > 스크리블 효과',
        placement: 'MenuBar',
        name: '스크리블 효과',
    },
    {
        id: 2164261054,
        label: '창 > 그래픽 스타일 라이브러리 > 예술 효과',
        placement: 'MenuBar',
        name: '예술 효과',
    },
    {
        id: 2164261055,
        label: '창 > 그래픽 스타일 라이브러리 > 이미지 효과',
        placement: 'MenuBar',
        name: '이미지 효과',
    },
    {
        id: 2164261056,
        label: '창 > 그래픽 스타일 라이브러리 > 조명 스타일',
        placement: 'MenuBar',
        name: '조명 스타일',
    },
    {
        id: 2164261057,
        label: '창 > 그래픽 스타일 라이브러리 > 타이프 효과',
        placement: 'MenuBar',
        name: '타이프 효과',
    },
    {
        id: 2164261058,
        label: '창 > 그래픽 스타일 라이브러리 > 텍스처',
        placement: 'MenuBar',
        name: '텍스처',
    },
    {
        id: 2164261061,
        label: '창 > 그래픽 스타일 라이브러리 > 기타 라이브러리...',
        placement: 'MenuBar',
        name: '기타 라이브러리...',
    },
    {
        id: 2164261062,
        label: '창 > 심볼',
        placement: 'MenuBar',
        name: '심볼',
    },
    {
        id: 2164261064,
        label: '창 > 심볼 라이브러리 > 3D 심볼',
        placement: 'MenuBar',
        name: '3D 심볼',
    },
    {
        id: 2164261065,
        label: '창 > 심볼 라이브러리 > 가보',
        placement: 'MenuBar',
        name: '가보',
    },
    {
        id: 2164261066,
        label: '창 > 심볼 라이브러리 > 격동적인 과학',
        placement: 'MenuBar',
        name: '격동적인 과학',
    },
    {
        id: 2164261067,
        label: '창 > 심볼 라이브러리 > 기본',
        placement: 'MenuBar',
        name: '기본',
    },
    {
        id: 2164261068,
        label: '창 > 심볼 라이브러리 > 꽃',
        placement: 'MenuBar',
        name: '꽃',
    },
    {
        id: 2164261069,
        label: '창 > 심볼 라이브러리 > 레갈 벡터 팩',
        placement: 'MenuBar',
        name: '레갈 벡터 팩',
    },
    {
        id: 2164261070,
        label: '창 > 심볼 라이브러리 > 로고 요소',
        placement: 'MenuBar',
        name: '로고 요소',
    },
    {
        id: 2164261071,
        label: '창 > 심볼 라이브러리 > 리트로',
        placement: 'MenuBar',
        name: '리트로',
    },
    {
        id: 2164261072,
        label: '창 > 심볼 라이브러리 > 맵',
        placement: 'MenuBar',
        name: '맵',
    },
    {
        id: 2164261073,
        label: '창 > 심볼 라이브러리 > 모바일',
        placement: 'MenuBar',
        name: '모바일',
    },
    {
        id: 2164261074,
        label: '창 > 심볼 라이브러리 > 모발과 모피',
        placement: 'MenuBar',
        name: '모발과 모피',
    },
    {
        id: 2164261075,
        label: '창 > 심볼 라이브러리 > 스시',
        placement: 'MenuBar',
        name: '스시',
    },
    {
        id: 2164261076,
        label: '창 > 심볼 라이브러리 > 예술 텍스처',
        placement: 'MenuBar',
        name: '예술 텍스처',
    },
    {
        id: 2164261077,
        label: '창 > 심볼 라이브러리 > 웹 단추와 막대',
        placement: 'MenuBar',
        name: '웹 단추와 막대',
    },
    {
        id: 2164261078,
        label: '창 > 심볼 라이브러리 > 웹 아이콘',
        placement: 'MenuBar',
        name: '웹 아이콘',
    },
    {
        id: 2164261079,
        label: '창 > 심볼 라이브러리 > 자연',
        placement: 'MenuBar',
        name: '자연',
    },
    {
        id: 2164261080,
        label: '창 > 심볼 라이브러리 > 점 패턴 벡터 팩',
        placement: 'MenuBar',
        name: '점 패턴 벡터 팩',
    },
    {
        id: 2164261081,
        label: '창 > 심볼 라이브러리 > 조명 리본',
        placement: 'MenuBar',
        name: '조명 리본',
    },
    {
        id: 2164261082,
        label: '창 > 심볼 라이브러리 > 조명 조직도',
        placement: 'MenuBar',
        name: '조명 조직도',
    },
    {
        id: 2164261083,
        label: '창 > 심볼 라이브러리 > 조명 플로우차트',
        placement: 'MenuBar',
        name: '조명 플로우차트',
    },
    {
        id: 2164261084,
        label: '창 > 심볼 라이브러리 > 지저분한 벡터 팩',
        placement: 'MenuBar',
        name: '지저분한 벡터 팩',
    },
    {
        id: 2164261085,
        label: '창 > 심볼 라이브러리 > 차트',
        placement: 'MenuBar',
        name: '차트',
    },
    {
        id: 2164261086,
        label: '창 > 심볼 라이브러리 > 축하',
        placement: 'MenuBar',
        name: '축하',
    },
    {
        id: 2164261087,
        label: '창 > 심볼 라이브러리 > 통신',
        placement: 'MenuBar',
        name: '통신',
    },
    {
        id: 2164261088,
        label: '창 > 심볼 라이브러리 > 티키',
        placement: 'MenuBar',
        name: '티키',
    },
    {
        id: 2164261089,
        label: '창 > 심볼 라이브러리 > 패션',
        placement: 'MenuBar',
        name: '패션',
    },
    {
        id: 2164261090,
        label: '창 > 심볼 라이브러리 > 현란한 벡터 팩',
        placement: 'MenuBar',
        name: '현란한 벡터 팩',
    },
    {
        id: 2164261091,
        label: '창 > 심볼 라이브러리 > 화살표',
        placement: 'MenuBar',
        name: '화살표',
    },
    {
        id: 2164261094,
        label: '창 > 심볼 라이브러리 > 기타 라이브러리...',
        placement: 'MenuBar',
        name: '기타 라이브러리...',
    },
    {
        id: 2164261096,
        label: '보기 > 특수 문자 안내선',
        placement: 'MenuBar',
        name: '특수 문자 안내선',
    },
    {
        id: 2164261097,
        label: '창 > 병합 미리보기',
        placement: 'MenuBar',
        name: '병합 미리보기',
    },
    {
        id: 2164261098,
        label: '창 > 작업 내역',
        placement: 'MenuBar',
        name: '작업 내역',
    },
    {
        id: 2164261100,
        label: '문자 > 글리프',
        placement: 'MenuBar',
        name: '글리프',
    },
    {
        id: 2164261101,
        label: '창 > 문자 > 글리프',
        placement: 'MenuBar',
        name: '글리프',
    },
    {
        id: 2164261102,
        label: '창 > 액션',
        placement: 'MenuBar',
        name: '액션',
    },
    {
        id: 2164261104,
        label: '선택 > 반전',
        placement: 'MenuBar',
        name: '반전',
    },
    {
        id: 2164261106,
        label: '효과 > 스타일화 > 그림자 만들기...',
        placement: 'MenuBar',
        name: '그림자 만들기...',
    },
    {
        id: 2164261107,
        label: '효과 > 스타일화 > 외부 광선...',
        placement: 'MenuBar',
        name: '외부 광선...',
    },
    {
        id: 2164261108,
        label: '효과 > 스타일화 > 내부 광선...',
        placement: 'MenuBar',
        name: '내부 광선...',
    },
    {
        id: 2164261110,
        label: '효과 > 도형으로 변환 > 사각형...',
        placement: 'MenuBar',
        name: '사각형...',
    },
    {
        id: 2164261111,
        label: '효과 > 도형으로 변환 > 둥근 사각형...',
        placement: 'MenuBar',
        name: '둥근 사각형...',
    },
    {
        id: 2164261112,
        label: '효과 > 도형으로 변환 > 원형...',
        placement: 'MenuBar',
        name: '원형...',
    },
    {
        id: 2164261113,
        label: '효과 > 스타일화 > 모퉁이 둥글리기...',
        placement: 'MenuBar',
        name: '모퉁이 둥글리기...',
    },
    {
        id: 2164261115,
        label: '오브젝트 > 패스 > 제거...',
        placement: 'MenuBar',
        name: '제거...',
    },
    {
        id: 2164261117,
        label: '편집 > 색상 편집 > 검정색 중복 인쇄...',
        placement: 'MenuBar',
        name: '검정색 중복 인쇄...',
    },
    {
        id: 2164261118,
        label: '효과 > 왜곡과 변형 > 자유 왜곡...',
        placement: 'MenuBar',
        name: '자유 왜곡...',
    },
    {
        id: 2164261119,
        label: '효과 > 왜곡과 변형 > 오목과 볼록...',
        placement: 'MenuBar',
        name: '오목과 볼록...',
    },
    {
        id: 2164261121,
        label: '오브젝트 > 텍스트 흐름 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261122,
        label: '오브젝트 > 텍스트 흐름 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261124,
        label: '오브젝트 > 텍스트 흐름 > 텍스트 흐름 옵션...',
        placement: 'MenuBar',
        name: '텍스트 흐름 옵션...',
    },
    {
        id: 2164261125,
        label: '효과 > 왜곡과 변형 > 비틀기...',
        placement: 'MenuBar',
        name: '비틀기...',
    },
    {
        id: 2164261126,
        label: '선택 > 오브젝트 > 클리핑 마스크',
        placement: 'MenuBar',
        name: '클리핑 마스크',
    },
    {
        id: 2164261127,
        label: '편집 > 색상 편집 > 앞에서 뒤로 혼합',
        placement: 'MenuBar',
        name: '앞에서 뒤로 혼합',
    },
    {
        id: 2164261128,
        label: '편집 > 색상 편집 > 가로로 혼합',
        placement: 'MenuBar',
        name: '가로로 혼합',
    },
    {
        id: 2164261129,
        label: '편집 > 색상 편집 > 세로로 혼합',
        placement: 'MenuBar',
        name: '세로로 혼합',
    },
    {
        id: 2164261130,
        label: '편집 > 색상 편집 > 색상 반전',
        placement: 'MenuBar',
        name: '색상 반전',
    },
    {
        id: 2164261131,
        label: '편집 > 색상 편집 > 회색 음영으로 변환',
        placement: 'MenuBar',
        name: '회색 음영으로 변환',
    },
    {
        id: 2164261132,
        label: '편집 > 색상 편집 > CMYK로 변환',
        placement: 'MenuBar',
        name: 'CMYK로 변환',
    },
    {
        id: 2164261133,
        label: '편집 > 색상 편집 > RGB로 변환',
        placement: 'MenuBar',
        name: 'RGB로 변환',
    },
    {
        id: 2164261134,
        label: '편집 > 색상 편집 > 채도...',
        placement: 'MenuBar',
        name: '채도...',
    },
    {
        id: 2164261136,
        label: '오브젝트 > 패스 > 고정점 추가',
        placement: 'MenuBar',
        name: '고정점 추가',
    },
    {
        id: 2164261137,
        label: '편집 > 색상 편집 > 색상 균형 조정...',
        placement: 'MenuBar',
        name: '색상 균형 조정...',
    },
    {
        id: 2164261138,
        label: '오브젝트 > 오브젝트 모자이크 만들기...',
        placement: 'MenuBar',
        name: '오브젝트 모자이크 만들기...',
    },
    {
        id: 2164261139,
        label: '효과 > 왜곡과 변형 > 거칠게 하기...',
        placement: 'MenuBar',
        name: '거칠게 하기...',
    },
    {
        id: 2164261140,
        label: '선택 > 재선택',
        placement: 'MenuBar',
        name: '재선택',
    },
    {
        id: 2164261142,
        label: '선택 > 동일하게 > 모양 및 텍스트',
        placement: 'MenuBar',
        name: '모양 및 텍스트',
    },
    {
        id: 2164261143,
        label: '선택 > 동일하게 > 텍스트',
        placement: 'MenuBar',
        name: '텍스트',
    },
    {
        id: 2164261145,
        label: '선택 > 동일하게 > 칠 색상',
        placement: 'MenuBar',
        name: '칠 색상',
    },
    {
        id: 2164261146,
        label: '선택 > 동일하게 > 그래픽 스타일',
        placement: 'MenuBar',
        name: '그래픽 스타일',
    },
    {
        id: 2164261147,
        label: '선택 > 동일하게 > 칠과 선',
        placement: 'MenuBar',
        name: '칠과 선',
    },
    {
        id: 2164261148,
        label: '선택 > 동일하게 > 선 색상',
        placement: 'MenuBar',
        name: '선 색상',
    },
    {
        id: 2164261149,
        label: '선택 > 동일하게 > 선 두께',
        placement: 'MenuBar',
        name: '선 두께',
    },
    {
        id: 2164261150,
        label: '선택 > 동일하게 > 혼합 모드',
        placement: 'MenuBar',
        name: '혼합 모드',
    },
    {
        id: 2164261151,
        label: '선택 > 동일하게 > 불투명도',
        placement: 'MenuBar',
        name: '불투명도',
    },
    {
        id: 2164261152,
        label: '선택 > 동일하게 > 모양',
        placement: 'MenuBar',
        name: '모양',
    },
    {
        id: 2164261153,
        label: '선택 > 동일하게 > 심볼 예제',
        placement: 'MenuBar',
        name: '심볼 예제',
    },
    {
        id: 2164261154,
        label: '선택 > 동일하게 > 연결된 텍스트 블록',
        placement: 'MenuBar',
        name: '연결된 텍스트 블록',
    },
    {
        id: 2164261155,
        label: '선택 > 동일하게 > 모양',
        placement: 'MenuBar',
        name: '모양',
    },
    {
        id: 2164261156,
        label: '선택 > 동일하게 > 모양 속성',
        placement: 'MenuBar',
        name: '모양 속성',
    },
    {
        id: 2164261157,
        label: '선택 > 동일하게 > 텍스트 채우기 색상',
        placement: 'MenuBar',
        name: '텍스트 채우기 색상',
    },
    {
        id: 2164261158,
        label: '선택 > 동일하게 > 텍스트 선 색상',
        placement: 'MenuBar',
        name: '텍스트 선 색상',
    },
    {
        id: 2164261159,
        label: '선택 > 동일하게 > 텍스트 채우기 및 선 색상',
        placement: 'MenuBar',
        name: '텍스트 채우기 및 선 색상',
    },
    {
        id: 2164261160,
        label: '선택 > 동일하게 > 글꼴 크기',
        placement: 'MenuBar',
        name: '글꼴 크기',
    },
    {
        id: 2164261161,
        label: '선택 > 동일하게 > 글꼴 군',
        placement: 'MenuBar',
        name: '글꼴 군',
    },
    {
        id: 2164261162,
        label: '선택 > 동일하게 > 글꼴 군 및 스타일',
        placement: 'MenuBar',
        name: '글꼴 군 및 스타일',
    },
    {
        id: 2164261163,
        label: '선택 > 동일하게 > 글꼴 군, 스타일 및 크기',
        placement: 'MenuBar',
        name: '글꼴 군, 스타일 및 크기',
    },
    {
        id: 2164261164,
        label: '선택 > 오브젝트 > 흩어진 점',
        placement: 'MenuBar',
        name: '흩어진 점',
    },
    {
        id: 2164261166,
        label: '선택 > 오브젝트 > 모든 문자 개체',
        placement: 'MenuBar',
        name: '모든 문자 개체',
    },
    {
        id: 2164261167,
        label: '선택 > 오브젝트 > 점 문자 개체',
        placement: 'MenuBar',
        name: '점 문자 개체',
    },
    {
        id: 2164261168,
        label: '선택 > 오브젝트 > 영역 문자 개체',
        placement: 'MenuBar',
        name: '영역 문자 개체',
    },
    {
        id: 2164261169,
        label: '효과 > 왜곡과 변형 > 지그재그...',
        placement: 'MenuBar',
        name: '지그재그...',
    },
    {
        id: 2164261170,
        label: '효과 > 자르기 표시',
        placement: 'MenuBar',
        name: '자르기 표시',
    },
    {
        id: 2164261171,
        label: '오브젝트 > 재단 보기 만들기',
        placement: 'MenuBar',
        name: '재단 보기 만들기',
    },
    {
        id: 2164261172,
        label: '파일 > 패키지...',
        placement: 'MenuBar',
        name: '패키지...',
    },
    {
        id: 2164261173,
        label: '창 > 레이어',
        placement: 'MenuBar',
        name: '레이어',
    },
    {
        id: 2164261176,
        label: '파일 > Bridge에서 찾아보기...',
        placement: 'MenuBar',
        name: 'Bridge에서 찾아보기...',
    },
    {
        id: 2164261177,
        label: '파일 > 파일 정보...',
        placement: 'MenuBar',
        name: '파일 정보...',
    },
    {
        id: 2164261178,
        label: '창 > 문서 정보',
        placement: 'MenuBar',
        name: '문서 정보',
    },
    {
        id: 2164261180,
        label: '효과 > 패스파인더 > 추가',
        placement: 'MenuBar',
        name: '추가',
    },
    {
        id: 2164261181,
        label: '효과 > 패스파인더 > 교차 영역',
        placement: 'MenuBar',
        name: '교차 영역',
    },
    {
        id: 2164261182,
        label: '효과 > 패스파인더 > 교차 영역 제외',
        placement: 'MenuBar',
        name: '교차 영역 제외',
    },
    {
        id: 2164261183,
        label: '효과 > 패스파인더 > 제외',
        placement: 'MenuBar',
        name: '제외',
    },
    {
        id: 2164261184,
        label: '효과 > 패스파인더 > 이면 오브젝트 제외',
        placement: 'MenuBar',
        name: '이면 오브젝트 제외',
    },
    {
        id: 2164261185,
        label: '효과 > 패스파인더 > 나누기',
        placement: 'MenuBar',
        name: '나누기',
    },
    {
        id: 2164261186,
        label: '효과 > 패스파인더 > 동색 오브젝트 분리',
        placement: 'MenuBar',
        name: '동색 오브젝트 분리',
    },
    {
        id: 2164261187,
        label: '효과 > 패스파인더 > 병합',
        placement: 'MenuBar',
        name: '병합',
    },
    {
        id: 2164261188,
        label: '효과 > 패스파인더 > 자르기',
        placement: 'MenuBar',
        name: '자르기',
    },
    {
        id: 2164261189,
        label: '효과 > 패스파인더 > 윤곽선',
        placement: 'MenuBar',
        name: '윤곽선',
    },
    {
        id: 2164261190,
        label: '효과 > 패스파인더 > 교차색 짙게 혼합',
        placement: 'MenuBar',
        name: '교차색 짙게 혼합',
    },
    {
        id: 2164261191,
        label: '효과 > 패스파인더 > 교차색 옅게 혼합...',
        placement: 'MenuBar',
        name: '교차색 옅게 혼합...',
    },
    {
        id: 2164261192,
        label: '효과 > 패스파인더 > 트랩...',
        placement: 'MenuBar',
        name: '트랩...',
    },
    {
        id: 2164261193,
        label: '보기 > 라이브 페인트 간격 표시',
        placement: 'MenuBar',
        name: '라이브 페인트 간격 표시',
    },
    {
        id: 2164261196,
        label: '오브젝트 > 라이브 페인트 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261197,
        label: '오브젝트 > 라이브 페인트 > 병합',
        placement: 'MenuBar',
        name: '병합',
    },
    {
        id: 2164261198,
        label: '오브젝트 > 라이브 페인트 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261200,
        label: '오브젝트 > 라이브 페인트 > 간격 옵션...',
        placement: 'MenuBar',
        name: '간격 옵션...',
    },
    {
        id: 2164261202,
        label: '오브젝트 > 라이브 페인트 > 확장',
        placement: 'MenuBar',
        name: '확장',
    },
    {
        id: 2164261203,
        label: '효과 > 스타일화 > 스크리블...',
        placement: 'MenuBar',
        name: '스크리블...',
    },
    {
        id: 2164261205,
        label: '오브젝트 > 둘러싸기 왜곡 > 뒤틀기로 만들기...',
        placement: 'MenuBar',
        name: '뒤틀기로 만들기...',
    },
    {
        id: 2164261206,
        label: '오브젝트 > 둘러싸기 왜곡 > 메시로 만들기...',
        placement: 'MenuBar',
        name: '메시로 만들기...',
    },
    {
        id: 2164261207,
        label: '오브젝트 > 둘러싸기 왜곡 > 최상위 오브젝트에 맞추기',
        placement: 'MenuBar',
        name: '최상위 오브젝트에 맞추기',
    },
    {
        id: 2164261208,
        label: '오브젝트 > 둘러싸기 왜곡 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261210,
        label: '오브젝트 > 둘러싸기 왜곡 > 둘러싸기 옵션...',
        placement: 'MenuBar',
        name: '둘러싸기 옵션...',
    },
    {
        id: 2164261212,
        label: '오브젝트 > 둘러싸기 왜곡 > 확장',
        placement: 'MenuBar',
        name: '확장',
    },
    {
        id: 2164261214,
        label: '오브젝트 > 둘러싸기 왜곡 > 내용 편집',
        placement: 'MenuBar',
        name: '내용 편집',
    },
    {
        id: 2164261216,
        label: '효과 > 변형 > 부채꼴...',
        placement: 'MenuBar',
        name: '부채꼴...',
    },
    {
        id: 2164261217,
        label: '효과 > 변형 > 아래 부채꼴...',
        placement: 'MenuBar',
        name: '아래 부채꼴...',
    },
    {
        id: 2164261218,
        label: '효과 > 변형 > 위 부채꼴...',
        placement: 'MenuBar',
        name: '위 부채꼴...',
    },
    {
        id: 2164261219,
        label: '효과 > 변형 > 아치...',
        placement: 'MenuBar',
        name: '아치...',
    },
    {
        id: 2164261220,
        label: '효과 > 변형 > 돌출...',
        placement: 'MenuBar',
        name: '돌출...',
    },
    {
        id: 2164261221,
        label: '효과 > 변형 > 아래쪽 조개 모양...',
        placement: 'MenuBar',
        name: '아래쪽 조개 모양...',
    },
    {
        id: 2164261222,
        label: '효과 > 변형 > 위쪽 조개 모양...',
        placement: 'MenuBar',
        name: '위쪽 조개 모양...',
    },
    {
        id: 2164261223,
        label: '효과 > 변형 > 깃발...',
        placement: 'MenuBar',
        name: '깃발...',
    },
    {
        id: 2164261224,
        label: '효과 > 변형 > 물결...',
        placement: 'MenuBar',
        name: '물결...',
    },
    {
        id: 2164261225,
        label: '효과 > 변형 > 물고기...',
        placement: 'MenuBar',
        name: '물고기...',
    },
    {
        id: 2164261226,
        label: '효과 > 변형 > 상승...',
        placement: 'MenuBar',
        name: '상승...',
    },
    {
        id: 2164261227,
        label: '효과 > 변형 > 물고기 눈 모양...',
        placement: 'MenuBar',
        name: '물고기 눈 모양...',
    },
    {
        id: 2164261228,
        label: '효과 > 변형 > 부풀리기...',
        placement: 'MenuBar',
        name: '부풀리기...',
    },
    {
        id: 2164261229,
        label: '효과 > 변형 > 양쪽 누르기...',
        placement: 'MenuBar',
        name: '양쪽 누르기...',
    },
    {
        id: 2164261230,
        label: '효과 > 변형 > 비틀기...',
        placement: 'MenuBar',
        name: '비틀기...',
    },
    {
        id: 2164261231,
        label: '오브젝트 > 확장...',
        placement: 'MenuBar',
        name: '확장...',
    },
    {
        id: 2164261233,
        label: '편집 > 맞춤법 > 자동 맞춤법 검사',
        placement: 'MenuBar',
        name: '자동 맞춤법 검사',
    },
    {
        id: 2164261234,
        label: '편집 > 맞춤법 > 맞춤법 검사...',
        placement: 'MenuBar',
        name: '맞춤법 검사...',
    },
    {
        id: 2164261235,
        label: '선택 > 전역 편집 시작',
        placement: 'MenuBar',
        name: '전역 편집 시작',
    },
    {
        id: 2164261236,
        label: 'Illustrator > 환경 설정 > 성능...',
        placement: 'MenuBar',
        name: '성능...',
    },
    {
        id: 2164261237,
        label: 'Illustrator > 환경 설정 > 파일 처리...',
        placement: 'MenuBar',
        name: '파일 처리...',
    },
    {
        id: 2164261238,
        label: 'Illustrator > 환경 설정 > 클립보드 처리...',
        placement: 'MenuBar',
        name: '클립보드 처리...',
    },
    {
        id: 2164261239,
        label: 'Illustrator > 환경 설정 > 검정 색상 표현...',
        placement: 'MenuBar',
        name: '검정 색상 표현...',
    },
    {
        id: 2164261240,
        label: 'Illustrator > 환경 설정 > 장치...',
        placement: 'MenuBar',
        name: '장치...',
    },
    {
        id: 2164261241,
        label: '창 > 브러쉬',
        placement: 'MenuBar',
        name: '브러쉬',
    },
    {
        id: 2164261242,
        label: '선택 > 오브젝트 > 브러쉬 선',
        placement: 'MenuBar',
        name: '브러쉬 선',
    },
    {
        id: 2164261245,
        label: '창 > 브러쉬 라이브러리 > Wacom 6D 브러쉬 > 6d 아트 펜 브러쉬',
        placement: 'MenuBar',
        name: '6d 아트 펜 브러쉬',
    },
    {
        id: 2164261247,
        label: '창 > 브러쉬 라이브러리 > 강모 브러시 > 강모 브러쉬 라이브러리',
        placement: 'MenuBar',
        name: '강모 브러쉬 라이브러리',
    },
    {
        id: 2164261249,
        label: '창 > 브러쉬 라이브러리 > 벡터 팩 > 그런지 브러쉬 벡터 팩',
        placement: 'MenuBar',
        name: '그런지 브러쉬 벡터 팩',
    },
    {
        id: 2164261250,
        label: '창 > 브러쉬 라이브러리 > 벡터 팩 > 손으로 그린 브러쉬 벡터 팩',
        placement: 'MenuBar',
        name: '손으로 그린 브러쉬 벡터 팩',
    },
    {
        id: 2164261252,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_분필목탄연필',
        placement: 'MenuBar',
        name: '예술_분필목탄연필',
    },
    {
        id: 2164261253,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_붓글씨',
        placement: 'MenuBar',
        name: '예술_붓글씨',
    },
    {
        id: 2164261254,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_수채화 효과',
        placement: 'MenuBar',
        name: '예술_수채화 효과',
    },
    {
        id: 2164261255,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_스크롤 펜',
        placement: 'MenuBar',
        name: '예술_스크롤 펜',
    },
    {
        id: 2164261256,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_잉크',
        placement: 'MenuBar',
        name: '예술_잉크',
    },
    {
        id: 2164261257,
        label: '창 > 브러쉬 라이브러리 > 예술 > 예술_페인트브러쉬',
        placement: 'MenuBar',
        name: '예술_페인트브러쉬',
    },
    {
        id: 2164261259,
        label: '창 > 브러쉬 라이브러리 > 이미지 브러시 > 이미지 브러시 라이브러리',
        placement: 'MenuBar',
        name: '이미지 브러시 라이브러리',
    },
    {
        id: 2164261261,
        label: '창 > 브러쉬 라이브러리 > 장식 > 세련된 컬 및 꽃 브러쉬 세트',
        placement: 'MenuBar',
        name: '세련된 컬 및 꽃 브러쉬 세트',
    },
    {
        id: 2164261262,
        label: '창 > 브러쉬 라이브러리 > 장식 > 장식_배너와 씰',
        placement: 'MenuBar',
        name: '장식_배너와 씰',
    },
    {
        id: 2164261263,
        label: '창 > 브러쉬 라이브러리 > 장식 > 장식_산포',
        placement: 'MenuBar',
        name: '장식_산포',
    },
    {
        id: 2164261264,
        label: '창 > 브러쉬 라이브러리 > 장식 > 장식_텍스트 분할자',
        placement: 'MenuBar',
        name: '장식_텍스트 분할자',
    },
    {
        id: 2164261266,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_기본',
        placement: 'MenuBar',
        name: '테두리_기본',
    },
    {
        id: 2164261267,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_기하',
        placement: 'MenuBar',
        name: '테두리_기하',
    },
    {
        id: 2164261268,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_새문양',
        placement: 'MenuBar',
        name: '테두리_새문양',
    },
    {
        id: 2164261269,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_선',
        placement: 'MenuBar',
        name: '테두리_선',
    },
    {
        id: 2164261270,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_장식',
        placement: 'MenuBar',
        name: '테두리_장식',
    },
    {
        id: 2164261271,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_점선',
        placement: 'MenuBar',
        name: '테두리_점선',
    },
    {
        id: 2164261272,
        label: '창 > 브러쉬 라이브러리 > 테두리 > 테두리_프레임',
        placement: 'MenuBar',
        name: '테두리_프레임',
    },
    {
        id: 2164261274,
        label: '창 > 브러쉬 라이브러리 > 화살표 > 패턴 화살표',
        placement: 'MenuBar',
        name: '패턴 화살표',
    },
    {
        id: 2164261275,
        label: '창 > 브러쉬 라이브러리 > 화살표 > 화살표_특수',
        placement: 'MenuBar',
        name: '화살표_특수',
    },
    {
        id: 2164261276,
        label: '창 > 브러쉬 라이브러리 > 화살표 > 화살표_표준',
        placement: 'MenuBar',
        name: '화살표_표준',
    },
    {
        id: 2164261279,
        label: '창 > 브러쉬 라이브러리 > 기타 라이브러리...',
        placement: 'MenuBar',
        name: '기타 라이브러리...',
    },
    {
        id: 2164261280,
        label: '창 > 패스파인더',
        placement: 'MenuBar',
        name: '패스파인더',
    },
    {
        id: 2164261281,
        label: '편집 > 찾기 및 바꾸기...',
        placement: 'MenuBar',
        name: '찾기 및 바꾸기...',
    },
    {
        id: 2164261282,
        label: '편집 > 다음 찾기',
        placement: 'MenuBar',
        name: '다음 찾기',
    },
    {
        id: 2164261283,
        label: '효과 > 래스터화...',
        placement: 'MenuBar',
        name: '래스터화...',
    },
    {
        id: 2164261285,
        label: '효과 > 문서 래스터 효과 설정값...',
        placement: 'MenuBar',
        name: '문서 래스터 효과 설정값...',
    },
    {
        id: 2164261286,
        label: '오브젝트 > 래스터화...',
        placement: 'MenuBar',
        name: '래스터화...',
    },
    {
        id: 2164261288,
        label: '오브젝트 > 블렌드 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261289,
        label: '오브젝트 > 블렌드 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261291,
        label: '오브젝트 > 블렌드 > 블렌드 옵션...',
        placement: 'MenuBar',
        name: '블렌드 옵션...',
    },
    {
        id: 2164261293,
        label: '오브젝트 > 블렌드 > 확장',
        placement: 'MenuBar',
        name: '확장',
    },
    {
        id: 2164261295,
        label: '오브젝트 > 블렌드 > 스파인 바꾸기',
        placement: 'MenuBar',
        name: '스파인 바꾸기',
    },
    {
        id: 2164261296,
        label: '오브젝트 > 블렌드 > 스파인 반전',
        placement: 'MenuBar',
        name: '스파인 반전',
    },
    {
        id: 2164261297,
        label: '오브젝트 > 블렌드 > 앞과 뒤를 반전',
        placement: 'MenuBar',
        name: '앞과 뒤를 반전',
    },
    {
        id: 2164261299,
        label: '보기 > 분할 영역 표시',
        placement: 'MenuBar',
        name: '분할 영역 표시',
    },
    {
        id: 2164261300,
        label: '보기 > 분할 영역 잠금',
        placement: 'MenuBar',
        name: '분할 영역 잠금',
    },
    {
        id: 2164261303,
        label: '오브젝트 > 분할 영역 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261304,
        label: '오브젝트 > 분할 영역 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261306,
        label: '오브젝트 > 분할 영역 > 안내선에서 만들기',
        placement: 'MenuBar',
        name: '안내선에서 만들기',
    },
    {
        id: 2164261307,
        label: '오브젝트 > 분할 영역 > 선택물에서 만들기',
        placement: 'MenuBar',
        name: '선택물에서 만들기',
    },
    {
        id: 2164261309,
        label: '오브젝트 > 분할 영역 > 분할 영역 복제',
        placement: 'MenuBar',
        name: '분할 영역 복제',
    },
    {
        id: 2164261310,
        label: '오브젝트 > 분할 영역 > 분할 영역 결합',
        placement: 'MenuBar',
        name: '분할 영역 결합',
    },
    {
        id: 2164261311,
        label: '오브젝트 > 분할 영역 > 분할 영역 나누기...',
        placement: 'MenuBar',
        name: '분할 영역 나누기...',
    },
    {
        id: 2164261312,
        label: '오브젝트 > 분할 영역 > 모두 삭제',
        placement: 'MenuBar',
        name: '모두 삭제',
    },
    {
        id: 2164261314,
        label: '오브젝트 > 분할 영역 > 분할 영역 옵션...',
        placement: 'MenuBar',
        name: '분할 영역 옵션...',
    },
    {
        id: 2164261316,
        label: '오브젝트 > 분할 영역 > 대지로 클립',
        placement: 'MenuBar',
        name: '대지로 클립',
    },
    {
        id: 2164261317,
        label: '창 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261318,
        label: '파일 > 선택 분할 영역 저장...',
        placement: 'MenuBar',
        name: '선택 분할 영역 저장...',
    },
    {
        id: 2164261320,
        label: '효과 > SVG 필터 > SVG 필터 적용...',
        placement: 'MenuBar',
        name: 'SVG 필터 적용...',
    },
    {
        id: 2164261321,
        label: '효과 > SVG 필터 > SVG 필터 불러오기...',
        placement: 'MenuBar',
        name: 'SVG 필터 불러오기...',
    },
    {
        id: 2164261323,
        label: '효과 > 스타일화 > 패더...',
        placement: 'MenuBar',
        name: '패더...',
    },
    {
        id: 2164261325,
        label: '효과 > 3D 및 재질 > 입체화와 경사...',
        placement: 'MenuBar',
        name: '입체화와 경사...',
    },
    {
        id: 2164261326,
        label: '효과 > 3D 및 재질 > 축 중심 회전...',
        placement: 'MenuBar',
        name: '축 중심 회전...',
    },
    {
        id: 2164261327,
        label: '효과 > 3D 및 재질 > 부풀리기...',
        placement: 'MenuBar',
        name: '부풀리기...',
    },
    {
        id: 2164261328,
        label: '효과 > 3D 및 재질 > 회전...',
        placement: 'MenuBar',
        name: '회전...',
    },
    {
        id: 2164261329,
        label: '효과 > 3D 및 재질 > 재질...',
        placement: 'MenuBar',
        name: '재질...',
    },
    {
        id: 2164261331,
        label: '효과 > 3D 및 재질 > 3D(기본) > 입체화와 경사(기본)...',
        placement: 'MenuBar',
        name: '입체화와 경사(기본)...',
    },
    {
        id: 2164261332,
        label: '효과 > 3D 및 재질 > 3D(기본) > 축 중심 회전(기본)...',
        placement: 'MenuBar',
        name: '축 중심 회전(기본)...',
    },
    {
        id: 2164261333,
        label: '효과 > 3D 및 재질 > 3D(기본) > 회전(기본)...',
        placement: 'MenuBar',
        name: '회전(기본)...',
    },
    {
        id: 2164261334,
        label: '창 > SVG 상호 작용',
        placement: 'MenuBar',
        name: 'SVG 상호 작용',
    },
    {
        id: 2164261335,
        label: '오브젝트 > 이미지 자르기',
        placement: 'MenuBar',
        name: '이미지 자르기',
    },
    {
        id: 2164261336,
        label: '창 > 변수',
        placement: 'MenuBar',
        name: '변수',
    },
    {
        id: 2164261338,
        label: '창 > 자동 선택',
        placement: 'MenuBar',
        name: '자동 선택',
    },
    {
        id: 2164261339,
        label: '오브젝트 > 패스 > 오브젝트 아래로 나누기',
        placement: 'MenuBar',
        name: '오브젝트 아래로 나누기',
    },
    {
        id: 2164261340,
        label: '선택 > 오브젝트 > 강모 브러쉬 선',
        placement: 'MenuBar',
        name: '강모 브러쉬 선',
    },
    {
        id: 2164261342,
        label: '오브젝트 > 변형 > 테두리 상자 재설정',
        placement: 'MenuBar',
        name: '테두리 상자 재설정',
    },
    {
        id: 2164261343,
        label: '보기 > 테두리 상자 숨기기',
        placement: 'MenuBar',
        name: '테두리 상자 숨기기',
    },
    {
        id: 2164261344,
        label: '오브젝트 > 정돈 > 현재 레이어로 보내기',
        placement: 'MenuBar',
        name: '현재 레이어로 보내기',
    },
    {
        id: 2164261346,
        label: '오브젝트 > 잠금 > 모든 아트웍 위로',
        placement: 'MenuBar',
        name: '모든 아트웍 위로',
    },
    {
        id: 2164261347,
        label: '오브젝트 > 잠금 > 기타 레이어',
        placement: 'MenuBar',
        name: '기타 레이어',
    },
    {
        id: 2164261348,
        label: '오브젝트 > 숨기기 > 모든 아트웍 위로',
        placement: 'MenuBar',
        name: '모든 아트웍 위로',
    },
    {
        id: 2164261349,
        label: '오브젝트 > 숨기기 > 기타 레이어',
        placement: 'MenuBar',
        name: '기타 레이어',
    },
    {
        id: 2164261350,
        label: '선택 > 오브젝트 > 동일한 레이어의 모든 오브젝트',
        placement: 'MenuBar',
        name: '동일한 레이어의 모든 오브젝트',
    },
    {
        id: 2164261351,
        label: '선택 > 오브젝트 > 방향 핸들',
        placement: 'MenuBar',
        name: '방향 핸들',
    },
    {
        id: 2164261354,
        label: '선택 > 다음 오브젝트 위로',
        placement: 'MenuBar',
        name: '다음 오브젝트 위로',
    },
    {
        id: 2164261355,
        label: '선택 > 다음 오브젝트 아래로',
        placement: 'MenuBar',
        name: '다음 오브젝트 아래로',
    },
    {
        id: 2164261358,
        label: '선택 > 선택 항목 저장...',
        placement: 'MenuBar',
        name: '선택 항목 저장...',
    },
    {
        id: 2164261359,
        label: '선택 > 선택 항목 편집...',
        placement: 'MenuBar',
        name: '선택 항목 편집...',
    },
    {
        id: 2164261360,
        label: '선택 > 선택 영역 업데이트',
        placement: 'MenuBar',
        name: '선택 영역 업데이트',
    },
    {
        id: 2164261361,
        label: '오브젝트 > 패스 > 단순화...',
        placement: 'MenuBar',
        name: '단순화...',
    },
    {
        id: 2164261362,
        label: '오브젝트 > 패스 > 부드럽게…',
        placement: 'MenuBar',
        name: '부드럽게…',
    },
    {
        id: 2164261364,
        label: '오브젝트 > 목업 > 목업 미리보기',
        placement: 'MenuBar',
        name: '목업 미리보기',
    },
    {
        id: 2164261365,
        label: '오브젝트 > 목업 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261366,
        label: '오브젝트 > 목업 > 편집',
        placement: 'MenuBar',
        name: '편집',
    },
    {
        id: 2164261367,
        label: '효과 > 왜곡과 변형 > 비틀어 돌리기...',
        placement: 'MenuBar',
        name: '비틀어 돌리기...',
    },
    {
        id: 2164261371,
        label: '파일 > 스크립트 > 기타 스크립트...',
        placement: 'MenuBar',
        name: '기타 스크립트...',
    },
    {
        id: 2164261372,
        label: '창 > CSS 속성(사용되지 않음)',
        placement: 'MenuBar',
        name: 'CSS 속성(사용되지 않음)',
    },
    {
        id: 2164261374,
        label: '효과 > 패스 > 오브젝트 윤곽선',
        placement: 'MenuBar',
        name: '오브젝트 윤곽선',
    },
    {
        id: 2164261375,
        label: '창 > 색상',
        placement: 'MenuBar',
        name: '색상',
    },
    {
        id: 2164261377,
        label: '창 > 그레이디언트',
        placement: 'MenuBar',
        name: '그레이디언트',
    },
    {
        id: 2164261378,
        label: '창 > 획',
        placement: 'MenuBar',
        name: '획',
    },
    {
        id: 2164261379,
        label: '보기 > 그레이디언트 주석자 숨기기',
        placement: 'MenuBar',
        name: '그레이디언트 주석자 숨기기',
    },
    {
        id: 2164261380,
        label: '오브젝트 > 패스 > 패스 방향 반전',
        placement: 'MenuBar',
        name: '패스 방향 반전',
    },
    {
        id: 2164261381,
        label: '창 > 투명도',
        placement: 'MenuBar',
        name: '투명도',
    },
    {
        id: 2164261382,
        label: '보기 > 투명 격자 표시',
        placement: 'MenuBar',
        name: '투명 격자 표시',
    },
    {
        id: 2164261383,
        label: '창 > 견본',
        placement: 'MenuBar',
        name: '견본',
    },
    {
        id: 2164261386,
        label: '창 > 패턴 옵션',
        placement: 'MenuBar',
        name: '패턴 옵션',
    },
    {
        id: 2164261387,
        label: '창 > 패턴 생성(Beta)',
        placement: 'MenuBar',
        name: '패턴 생성(Beta)',
    },
    {
        id: 2164261389,
        label: '오브젝트 > 패턴 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261391,
        label: '오브젝트 > 패턴 > 패턴 편집',
        placement: 'MenuBar',
        name: '패턴 편집',
    },
    {
        id: 2164261392,
        label: '오브젝트 > 패턴 > 타일 가장자리 색상...',
        placement: 'MenuBar',
        name: '타일 가장자리 색상...',
    },
    {
        id: 2164261394,
        label: '오브젝트 > 패턴 > 패턴 생성(Beta)',
        placement: 'MenuBar',
        name: '패턴 생성(Beta)',
    },
    {
        id: 2164261395,
        label: '창 > 견본 라이브러리 > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261396,
        label: '창 > 견본 라이브러리 > 금속',
        placement: 'MenuBar',
        name: '금속',
    },
    {
        id: 2164261397,
        label: '창 > 견본 라이브러리 > 시스템(Macintosh)',
        placement: 'MenuBar',
        name: '시스템(Macintosh)',
    },
    {
        id: 2164261398,
        label: '창 > 견본 라이브러리 > 시스템(Windows)',
        placement: 'MenuBar',
        name: '시스템(Windows)',
    },
    {
        id: 2164261399,
        label: '창 > 견본 라이브러리 > 어린이 용품',
        placement: 'MenuBar',
        name: '어린이 용품',
    },
    {
        id: 2164261400,
        label: '창 > 견본 라이브러리 > 웹',
        placement: 'MenuBar',
        name: '웹',
    },
    {
        id: 2164261401,
        label: '창 > 견본 라이브러리 > 직물',
        placement: 'MenuBar',
        name: '직물',
    },
    {
        id: 2164261402,
        label: '창 > 견본 라이브러리 > 축하',
        placement: 'MenuBar',
        name: '축하',
    },
    {
        id: 2164261403,
        label: '창 > 견본 라이브러리 > 피부 톤',
        placement: 'MenuBar',
        name: '피부 톤',
    },
    {
        id: 2164261404,
        label: '창 > 견본 라이브러리 > 회사',
        placement: 'MenuBar',
        name: '회사',
    },
    {
        id: 2164261405,
        label: '창 > 견본 라이브러리 > 흐릿한 회색',
        placement: 'MenuBar',
        name: '흐릿한 회색',
    },
    {
        id: 2164261406,
        label: '창 > 견본 라이브러리 > 흙빛',
        placement: 'MenuBar',
        name: '흙빛',
    },
    {
        id: 2164261408,
        label: '창 > 견본 라이브러리 > 과학적 > 3등분',
        placement: 'MenuBar',
        name: '3등분',
    },
    {
        id: 2164261409,
        label: '창 > 견본 라이브러리 > 과학적 > 4등분',
        placement: 'MenuBar',
        name: '4등분',
    },
    {
        id: 2164261410,
        label: '창 > 견본 라이브러리 > 과학적 > 보색',
        placement: 'MenuBar',
        name: '보색',
    },
    {
        id: 2164261411,
        label: '창 > 견본 라이브러리 > 과학적 > 분할 보색',
        placement: 'MenuBar',
        name: '분할 보색',
    },
    {
        id: 2164261412,
        label: '창 > 견본 라이브러리 > 과학적 > 유사색',
        placement: 'MenuBar',
        name: '유사색',
    },
    {
        id: 2164261414,
        label: '창 > 견본 라이브러리 > 그라디언트 > 계절',
        placement: 'MenuBar',
        name: '계절',
    },
    {
        id: 2164261415,
        label: '창 > 견본 라이브러리 > 그라디언트 > 과일과 야채',
        placement: 'MenuBar',
        name: '과일과 야채',
    },
    {
        id: 2164261416,
        label: '창 > 견본 라이브러리 > 그라디언트 > 금속',
        placement: 'MenuBar',
        name: '금속',
    },
    {
        id: 2164261417,
        label: '창 > 견본 라이브러리 > 그라디언트 > 나무',
        placement: 'MenuBar',
        name: '나무',
    },
    {
        id: 2164261418,
        label: '창 > 견본 라이브러리 > 그라디언트 > 농도와 음영',
        placement: 'MenuBar',
        name: '농도와 음영',
    },
    {
        id: 2164261419,
        label: '창 > 견본 라이브러리 > 그라디언트 > 단순 방사형',
        placement: 'MenuBar',
        name: '단순 방사형',
    },
    {
        id: 2164261420,
        label: '창 > 견본 라이브러리 > 그라디언트 > 돌과 벽돌',
        placement: 'MenuBar',
        name: '돌과 벽돌',
    },
    {
        id: 2164261421,
        label: '창 > 견본 라이브러리 > 그라디언트 > 물',
        placement: 'MenuBar',
        name: '물',
    },
    {
        id: 2164261422,
        label: '창 > 견본 라이브러리 > 그라디언트 > 밝기',
        placement: 'MenuBar',
        name: '밝기',
    },
    {
        id: 2164261423,
        label: '창 > 견본 라이브러리 > 그라디언트 > 보석과 장신구',
        placement: 'MenuBar',
        name: '보석과 장신구',
    },
    {
        id: 2164261424,
        label: '창 > 견본 라이브러리 > 그라디언트 > 비네팅',
        placement: 'MenuBar',
        name: '비네팅',
    },
    {
        id: 2164261425,
        label: '창 > 견본 라이브러리 > 그라디언트 > 색상 조합',
        placement: 'MenuBar',
        name: '색상 조합',
    },
    {
        id: 2164261426,
        label: '창 > 견본 라이브러리 > 그라디언트 > 색상 조화',
        placement: 'MenuBar',
        name: '색상 조화',
    },
    {
        id: 2164261427,
        label: '창 > 견본 라이브러리 > 그라디언트 > 서서히 변경',
        placement: 'MenuBar',
        name: '서서히 변경',
    },
    {
        id: 2164261428,
        label: '창 > 견본 라이브러리 > 그라디언트 > 스펙트럼',
        placement: 'MenuBar',
        name: '스펙트럼',
    },
    {
        id: 2164261429,
        label: '창 > 견본 라이브러리 > 그라디언트 > 잎',
        placement: 'MenuBar',
        name: '잎',
    },
    {
        id: 2164261430,
        label: '창 > 견본 라이브러리 > 그라디언트 > 파스텔',
        placement: 'MenuBar',
        name: '파스텔',
    },
    {
        id: 2164261431,
        label: '창 > 견본 라이브러리 > 그라디언트 > 피부 톤',
        placement: 'MenuBar',
        name: '피부 톤',
    },
    {
        id: 2164261432,
        label: '창 > 견본 라이브러리 > 그라디언트 > 하늘',
        placement: 'MenuBar',
        name: '하늘',
    },
    {
        id: 2164261433,
        label: '창 > 견본 라이브러리 > 그라디언트 > 흐릿한 회색',
        placement: 'MenuBar',
        name: '흐릿한 회색',
    },
    {
        id: 2164261434,
        label: '창 > 견본 라이브러리 > 그라디언트 > 흙빛',
        placement: 'MenuBar',
        name: '흙빛',
    },
    {
        id: 2164261436,
        label: '창 > 견본 라이브러리 > 기본 견본 > 기본 RGB',
        placement: 'MenuBar',
        name: '기본 RGB',
    },
    {
        id: 2164261437,
        label: '창 > 견본 라이브러리 > 기본 견본 > 비디오 및 영화',
        placement: 'MenuBar',
        name: '비디오 및 영화',
    },
    {
        id: 2164261438,
        label: '창 > 견본 라이브러리 > 기본 견본 > 웹',
        placement: 'MenuBar',
        name: '웹',
    },
    {
        id: 2164261439,
        label: '창 > 견본 라이브러리 > 기본 견본 > 인쇄',
        placement: 'MenuBar',
        name: '인쇄',
    },
    {
        id: 2164261440,
        label: '창 > 견본 라이브러리 > 기본 견본 > 장치',
        placement: 'MenuBar',
        name: '장치',
    },
    {
        id: 2164261442,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 고대',
        placement: 'MenuBar',
        name: '고대',
    },
    {
        id: 2164261443,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 러시아 포스터 아트',
        placement: 'MenuBar',
        name: '러시아 포스터 아트',
    },
    {
        id: 2164261444,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 르네상스',
        placement: 'MenuBar',
        name: '르네상스',
    },
    {
        id: 2164261445,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 바로크',
        placement: 'MenuBar',
        name: '바로크',
    },
    {
        id: 2164261446,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 선사 시대',
        placement: 'MenuBar',
        name: '선사 시대',
    },
    {
        id: 2164261447,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 인상주의',
        placement: 'MenuBar',
        name: '인상주의',
    },
    {
        id: 2164261448,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 중세',
        placement: 'MenuBar',
        name: '중세',
    },
    {
        id: 2164261449,
        label: '창 > 견본 라이브러리 > 미술 작업 내역 > 팝 아트',
        placement: 'MenuBar',
        name: '팝 아트',
    },
    {
        id: 2164261451,
        label: '창 > 견본 라이브러리 > 색상 속성 > 따뜻함',
        placement: 'MenuBar',
        name: '따뜻함',
    },
    {
        id: 2164261452,
        label: '창 > 견본 라이브러리 > 색상 속성 > 밝게',
        placement: 'MenuBar',
        name: '밝게',
    },
    {
        id: 2164261453,
        label: '창 > 견본 라이브러리 > 색상 속성 > 밝음',
        placement: 'MenuBar',
        name: '밝음',
    },
    {
        id: 2164261454,
        label: '창 > 견본 라이브러리 > 색상 속성 > 어둡게',
        placement: 'MenuBar',
        name: '어둡게',
    },
    {
        id: 2164261455,
        label: '창 > 견본 라이브러리 > 색상 속성 > 옅게',
        placement: 'MenuBar',
        name: '옅게',
    },
    {
        id: 2164261456,
        label: '창 > 견본 라이브러리 > 색상 속성 > 차가움',
        placement: 'MenuBar',
        name: '차가움',
    },
    {
        id: 2164261457,
        label: '창 > 견본 라이브러리 > 색상 속성 > 채도 감소',
        placement: 'MenuBar',
        name: '채도 감소',
    },
    {
        id: 2164261458,
        label: '창 > 견본 라이브러리 > 색상 속성 > 채도',
        placement: 'MenuBar',
        name: '채도',
    },
    {
        id: 2164261460,
        label: '창 > 견본 라이브러리 > 색상 책 > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261461,
        label: '창 > 견본 라이브러리 > 색상 책 > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261462,
        label: '창 > 견본 라이브러리 > 색상 책 > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261463,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261464,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261465,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261466,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261467,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261468,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261469,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261470,
        label: '창 > 견본 라이브러리 > 색상 책 > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261471,
        label: '창 > 견본 라이브러리 > 색상 책 > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261472,
        label: '창 > 견본 라이브러리 > 색상 책 > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261473,
        label: '창 > 견본 라이브러리 > 색상 책 > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261475,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > DIC Color Guide.acbl',
        placement: 'MenuBar',
        name: 'DIC Color Guide.acbl',
    },
    {
        id: 2164261476,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > HKS E.acbl',
        placement: 'MenuBar',
        name: 'HKS E.acbl',
    },
    {
        id: 2164261477,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > HKS K.acbl',
        placement: 'MenuBar',
        name: 'HKS K.acbl',
    },
    {
        id: 2164261478,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > HKS N.acbl',
        placement: 'MenuBar',
        name: 'HKS N.acbl',
    },
    {
        id: 2164261479,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > HKS Z.acbl',
        placement: 'MenuBar',
        name: 'HKS Z.acbl',
    },
    {
        id: 2164261480,
        label: '창 > 견본 라이브러리 > 색상 책 > 이전 > TOYO Color Finder.acbl',
        placement: 'MenuBar',
        name: 'TOYO Color Finder.acbl',
    },
    {
        id: 2164261482,
        label: '창 > 견본 라이브러리 > 음식 > 과일',
        placement: 'MenuBar',
        name: '과일',
    },
    {
        id: 2164261483,
        label: '창 > 견본 라이브러리 > 음식 > 사탕',
        placement: 'MenuBar',
        name: '사탕',
    },
    {
        id: 2164261484,
        label: '창 > 견본 라이브러리 > 음식 > 아이스크림',
        placement: 'MenuBar',
        name: '아이스크림',
    },
    {
        id: 2164261485,
        label: '창 > 견본 라이브러리 > 음식 > 음료',
        placement: 'MenuBar',
        name: '음료',
    },
    {
        id: 2164261486,
        label: '창 > 견본 라이브러리 > 음식 > 채소',
        placement: 'MenuBar',
        name: '채소',
    },
    {
        id: 2164261488,
        label: '창 > 견본 라이브러리 > 자연 > 계절',
        placement: 'MenuBar',
        name: '계절',
    },
    {
        id: 2164261489,
        label: '창 > 견본 라이브러리 > 자연 > 꽃',
        placement: 'MenuBar',
        name: '꽃',
    },
    {
        id: 2164261490,
        label: '창 > 견본 라이브러리 > 자연 > 돌과 벽돌',
        placement: 'MenuBar',
        name: '돌과 벽돌',
    },
    {
        id: 2164261491,
        label: '창 > 견본 라이브러리 > 자연 > 잎',
        placement: 'MenuBar',
        name: '잎',
    },
    {
        id: 2164261492,
        label: '창 > 견본 라이브러리 > 자연 > 풍경',
        placement: 'MenuBar',
        name: '풍경',
    },
    {
        id: 2164261493,
        label: '창 > 견본 라이브러리 > 자연 > 해변',
        placement: 'MenuBar',
        name: '해변',
    },
    {
        id: 2164261496,
        label: '창 > 견본 라이브러리 > 패턴 > 기본 그래픽 > 기본 그래픽_선',
        placement: 'MenuBar',
        name: '기본 그래픽_선',
    },
    {
        id: 2164261497,
        label: '창 > 견본 라이브러리 > 패턴 > 기본 그래픽 > 기본 그래픽_점',
        placement: 'MenuBar',
        name: '기본 그래픽_점',
    },
    {
        id: 2164261498,
        label: '창 > 견본 라이브러리 > 패턴 > 기본 그래픽 > 기본 그래픽_텍스처',
        placement: 'MenuBar',
        name: '기본 그래픽_텍스처',
    },
    {
        id: 2164261500,
        label: '창 > 견본 라이브러리 > 패턴 > 자연 > 자연_동물 가죽',
        placement: 'MenuBar',
        name: '자연_동물 가죽',
    },
    {
        id: 2164261501,
        label: '창 > 견본 라이브러리 > 패턴 > 자연 > 자연_잎',
        placement: 'MenuBar',
        name: '자연_잎',
    },
    {
        id: 2164261503,
        label: '창 > 견본 라이브러리 > 패턴 > 장식 > 본스터 패턴',
        placement: 'MenuBar',
        name: '본스터 패턴',
    },
    {
        id: 2164261504,
        label: '창 > 견본 라이브러리 > 패턴 > 장식 > 장식용 레거시',
        placement: 'MenuBar',
        name: '장식용 레거시',
    },
    {
        id: 2164261507,
        label: '창 > 견본 라이브러리 > 기타 라이브러리...',
        placement: 'MenuBar',
        name: '기타 라이브러리...',
    },
    {
        id: 2164261508,
        label: '창 > 색상 안내',
        placement: 'MenuBar',
        name: '색상 안내',
    },
    {
        id: 2164261509,
        label: '편집 > 색상 편집 > 아트웍 색상 변경...',
        placement: 'MenuBar',
        name: '아트웍 색상 변경...',
    },
    {
        id: 2164261512,
        label: '편집 > 색상 편집 > 생성형 다시 칠하기',
        placement: 'MenuBar',
        name: '생성형 다시 칠하기',
    },
    {
        id: 2164261514,
        label: '편집 > 색상 편집 > 사전 설정으로 색상 변경 > 색상 라이브러리...',
        placement: 'MenuBar',
        name: '색상 라이브러리...',
    },
    {
        id: 2164261515,
        label: '편집 > 색상 편집 > 사전 설정으로 색상 변경 > 단독 색상',
        placement: 'MenuBar',
        name: '단독 색상',
    },
    {
        id: 2164261516,
        label: '편집 > 색상 편집 > 사전 설정으로 색상 변경 > 2색',
        placement: 'MenuBar',
        name: '2색',
    },
    {
        id: 2164261517,
        label: '편집 > 색상 편집 > 사전 설정으로 색상 변경 > 세 가지 색상',
        placement: 'MenuBar',
        name: '세 가지 색상',
    },
    {
        id: 2164261518,
        label: '편집 > 색상 편집 > 사전 설정으로 색상 변경 > 색상 조화',
        placement: 'MenuBar',
        name: '색상 조화',
    },
    {
        id: 2164261519,
        label: '창 > 제어',
        placement: 'MenuBar',
        name: '제어',
    },
    {
        id: 2164261520,
        label: '창 > 상황별 작업 표시줄',
        placement: 'MenuBar',
        name: '상황별 작업 표시줄',
    },
    {
        id: 2164261522,
        label: '오브젝트 > 부분 재배열 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261523,
        label: '오브젝트 > 부분 재배열 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261524,
        label: '오브젝트 > 부분 재배열 > 편집',
        placement: 'MenuBar',
        name: '편집',
    },
    {
        id: 2164261525,
        label: '창 > 정렬',
        placement: 'MenuBar',
        name: '정렬',
    },
    {
        id: 2164261527,
        label: '오브젝트 > 정렬 > 수평 왼쪽 정렬',
        placement: 'MenuBar',
        name: '수평 왼쪽 정렬',
    },
    {
        id: 2164261528,
        label: '오브젝트 > 정렬 > 수평 가운데 정렬',
        placement: 'MenuBar',
        name: '수평 가운데 정렬',
    },
    {
        id: 2164261529,
        label: '오브젝트 > 정렬 > 수평 오른쪽 정렬',
        placement: 'MenuBar',
        name: '수평 오른쪽 정렬',
    },
    {
        id: 2164261530,
        label: '오브젝트 > 정렬 > 수직 위쪽 정렬',
        placement: 'MenuBar',
        name: '수직 위쪽 정렬',
    },
    {
        id: 2164261531,
        label: '오브젝트 > 정렬 > 수직 가운데 정렬',
        placement: 'MenuBar',
        name: '수직 가운데 정렬',
    },
    {
        id: 2164261532,
        label: '오브젝트 > 정렬 > 수직 아래쪽 정렬',
        placement: 'MenuBar',
        name: '수직 아래쪽 정렬',
    },
    {
        id: 2164261534,
        label: '오브젝트 > 분포 > 세로 위 분포',
        placement: 'MenuBar',
        name: '세로 위 분포',
    },
    {
        id: 2164261535,
        label: '오브젝트 > 분포 > 세로 가운데 분포',
        placement: 'MenuBar',
        name: '세로 가운데 분포',
    },
    {
        id: 2164261536,
        label: '오브젝트 > 분포 > 세로 아래 분포',
        placement: 'MenuBar',
        name: '세로 아래 분포',
    },
    {
        id: 2164261537,
        label: '오브젝트 > 분포 > 가로 왼쪽 분포',
        placement: 'MenuBar',
        name: '가로 왼쪽 분포',
    },
    {
        id: 2164261538,
        label: '오브젝트 > 분포 > 가로 가운데 분포',
        placement: 'MenuBar',
        name: '가로 가운데 분포',
    },
    {
        id: 2164261539,
        label: '오브젝트 > 분포 > 가로 오른쪽 분포',
        placement: 'MenuBar',
        name: '가로 오른쪽 분포',
    },
    {
        id: 2164261540,
        label: '창 > 변형',
        placement: 'MenuBar',
        name: '변형',
    },
    {
        id: 2164261541,
        label: '보기 > 모퉁이 위젯 숨기기',
        placement: 'MenuBar',
        name: '모퉁이 위젯 숨기기',
    },
    {
        id: 2164261543,
        label: '오브젝트 > 반복 > 방사형',
        placement: 'MenuBar',
        name: '방사형',
    },
    {
        id: 2164261544,
        label: '오브젝트 > 반복 > 격자',
        placement: 'MenuBar',
        name: '격자',
    },
    {
        id: 2164261545,
        label: '오브젝트 > 반복 > 뒤집기',
        placement: 'MenuBar',
        name: '뒤집기',
    },
    {
        id: 2164261547,
        label: '오브젝트 > 반복 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261548,
        label: '오브젝트 > 반복 > 옵션...',
        placement: 'MenuBar',
        name: '옵션...',
    },
    {
        id: 2164261550,
        label: '오브젝트 > 패스상의 오브젝트 > 부착…',
        placement: 'MenuBar',
        name: '부착…',
    },
    {
        id: 2164261551,
        label: '오브젝트 > 패스상의 오브젝트 > 옵션...',
        placement: 'MenuBar',
        name: '옵션...',
    },
    {
        id: 2164261552,
        label: '오브젝트 > 패스상의 오브젝트 > 확장',
        placement: 'MenuBar',
        name: '확장',
    },
    {
        id: 2164261553,
        label: '효과 > 패스 > 윤곽 선',
        placement: 'MenuBar',
        name: '윤곽 선',
    },
    {
        id: 2164261554,
        label: '효과 > 패스 > 오프셋 패스…',
        placement: 'MenuBar',
        name: '오프셋 패스…',
    },
    {
        id: 2164261555,
        label: '오브젝트 > 패스 > 윤곽 선',
        placement: 'MenuBar',
        name: '윤곽 선',
    },
    {
        id: 2164261556,
        label: '오브젝트 > 패스 > 오프셋 패스…',
        placement: 'MenuBar',
        name: '오프셋 패스…',
    },
    {
        id: 2164261558,
        label: '창 > 도구 모음 > 기본',
        placement: 'MenuBar',
        name: '기본',
    },
    {
        id: 2164261559,
        label: '창 > 도구 모음 > 고급',
        placement: 'MenuBar',
        name: '고급',
    },
    {
        id: 2164261560,
        label: '창 > 도구 모음 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261562,
        label: '창 > 도구 모음 > 새 도구 모음...',
        placement: 'MenuBar',
        name: '새 도구 모음...',
    },
    {
        id: 2164261563,
        label: '창 > 도구 모음 > 도구 모음 관리...',
        placement: 'MenuBar',
        name: '도구 모음 관리...',
    },
    {
        id: 2164261564,
        label: '창 > 특성',
        placement: 'MenuBar',
        name: '특성',
    },
    {
        id: 2164261565,
        label: '문자 > Adobe Fonts에서 추가...',
        placement: 'MenuBar',
        name: 'Adobe Fonts에서 추가...',
    },
    {
        id: 2164261566,
        label: '문자 > 없는 글꼴 확인...',
        placement: 'MenuBar',
        name: '없는 글꼴 확인...',
    },
    {
        id: 2164261567,
        label: '도움말 > 커뮤니티 지원',
        placement: 'MenuBar',
        name: '커뮤니티 지원',
    },
    {
        id: 2164261568,
        label: '도움말 > 버그/기능 요청 제출...',
        placement: 'MenuBar',
        name: '버그/기능 요청 제출...',
    },
    {
        id: 2164261570,
        label: '오브젝트 > 픽셀 퍼펙트 만들기',
        placement: 'MenuBar',
        name: '픽셀 퍼펙트 만들기',
    },
    {
        id: 2164261571,
        label: '창 > 문자 > 리플로우 뷰어',
        placement: 'MenuBar',
        name: '리플로우 뷰어',
    },
    {
        id: 2164261572,
        label: '도움말 > 생성형 AI 사용자 가이드라인',
        placement: 'MenuBar',
        name: '생성형 AI 사용자 가이드라인',
    },
    {
        id: 2164261574,
        label: '편집 > 인쇄 사전 설정...',
        placement: 'MenuBar',
        name: '인쇄 사전 설정...',
    },
    {
        id: 2164261576,
        label: '파일 > 인쇄...',
        placement: 'MenuBar',
        name: '인쇄...',
    },
    {
        id: 2164261577,
        label: '편집 > 투명도 병합 사전 설정...',
        placement: 'MenuBar',
        name: '투명도 병합 사전 설정...',
    },
    {
        id: 2164261578,
        label: '오브젝트 > 투명도 병합...',
        placement: 'MenuBar',
        name: '투명도 병합...',
    },
    {
        id: 2164261580,
        label: '오브젝트 > 모양 > 모양으로 변환',
        placement: 'MenuBar',
        name: '모양으로 변환',
    },
    {
        id: 2164261581,
        label: '오브젝트 > 모양 > 모양 확장',
        placement: 'MenuBar',
        name: '모양 확장',
    },
    {
        id: 2164261582,
        label: '창 > 목업',
        placement: 'MenuBar',
        name: '목업',
    },
    {
        id: 2164261583,
        label: '창 > 생성된 베리에이션',
        placement: 'MenuBar',
        name: '생성된 베리에이션',
    },
    {
        id: 2164261584,
        label: '오브젝트 > 벡터 생성(Beta)...',
        placement: 'MenuBar',
        name: '벡터 생성(Beta)...',
    },
    {
        id: 2164261585,
        label: '파일 > 벡터 생성(Beta)...',
        placement: 'MenuBar',
        name: '벡터 생성(Beta)...',
    },
    {
        id: 2164261586,
        label: '오브젝트 > 생성형 모양 채우기(Beta)...',
        placement: 'MenuBar',
        name: '생성형 모양 채우기(Beta)...',
    },
    {
        id: 2164261587,
        label: '창 > 3D 및 재질',
        placement: 'MenuBar',
        name: '3D 및 재질',
    },
    {
        id: 2164261589,
        label: '오브젝트 > 원근감 > 활성 평면에 첨부',
        placement: 'MenuBar',
        name: '활성 평면에 첨부',
    },
    {
        id: 2164261590,
        label: '오브젝트 > 원근감 > 원근감과 함께 풀기',
        placement: 'MenuBar',
        name: '원근감과 함께 풀기',
    },
    {
        id: 2164261591,
        label: '오브젝트 > 원근감 > 오브젝트가 일치하도록 평면 이동',
        placement: 'MenuBar',
        name: '오브젝트가 일치하도록 평면 이동',
    },
    {
        id: 2164261592,
        label: '오브젝트 > 원근감 > 텍스트 편집',
        placement: 'MenuBar',
        name: '텍스트 편집',
    },
    {
        id: 2164261593,
        label: '편집 > 원근 격자 사전 설정...',
        placement: 'MenuBar',
        name: '원근 격자 사전 설정...',
    },
    {
        id: 2164261596,
        label: '보기 > 원근감 격자 > 격자 표시',
        placement: 'MenuBar',
        name: '격자 표시',
    },
    {
        id: 2164261597,
        label: '보기 > 원근감 격자 > 눈금자 표시',
        placement: 'MenuBar',
        name: '눈금자 표시',
    },
    {
        id: 2164261598,
        label: '보기 > 원근감 격자 > 격자에 물리기',
        placement: 'MenuBar',
        name: '격자에 물리기',
    },
    {
        id: 2164261599,
        label: '보기 > 원근감 격자 > 격자 잠그기',
        placement: 'MenuBar',
        name: '격자 잠그기',
    },
    {
        id: 2164261600,
        label: '보기 > 원근감 격자 > 정점 잠그기',
        placement: 'MenuBar',
        name: '정점 잠그기',
    },
    {
        id: 2164261602,
        label: '보기 > 원근감 격자 > 격자 정의...',
        placement: 'MenuBar',
        name: '격자 정의...',
    },
    {
        id: 2164261608,
        label: '보기 > 원근감 격자 > 사전 설정으로 격자 저장...',
        placement: 'MenuBar',
        name: '사전 설정으로 격자 저장...',
    },
    {
        id: 2164261609,
        label: '창 > 이미지 추적',
        placement: 'MenuBar',
        name: '이미지 추적',
    },
    {
        id: 2164261611,
        label: '오브젝트 > 이미지 추적 > 만들기',
        placement: 'MenuBar',
        name: '만들기',
    },
    {
        id: 2164261612,
        label: '오브젝트 > 이미지 추적 > 추적 후 확장',
        placement: 'MenuBar',
        name: '추적 후 확장',
    },
    {
        id: 2164261613,
        label: '오브젝트 > 이미지 추적 > 풀기',
        placement: 'MenuBar',
        name: '풀기',
    },
    {
        id: 2164261615,
        label: '오브젝트 > 이미지 추적 > 확장',
        placement: 'MenuBar',
        name: '확장',
    },
    {
        id: 2164261616,
        label: '효과 > 흐림 효과 > 가우시안 흐림...',
        placement: 'MenuBar',
        name: '가우시안 흐림...',
    },
    {
        id: 2164261617,
        label: '편집 > Adobe PDF 사전 설정...',
        placement: 'MenuBar',
        name: 'Adobe PDF 사전 설정...',
    },
    {
        id: 2164261618,
        label: '창 > 자산 내보내기',
        placement: 'MenuBar',
        name: '자산 내보내기',
    },
    {
        id: 2164261619,
        label: '파일 > 편집하도록 초대...',
        placement: 'MenuBar',
        name: '편집하도록 초대...',
    },
    {
        id: 2164261620,
        label: '파일 > 검토용으로 공유...',
        placement: 'MenuBar',
        name: '검토용으로 공유...',
    },
    {
        id: 2164261621,
        label: '보기 > 원근감 격자 > 1점 투시 > [1P-표준 보기]',
        placement: 'MenuBar',
        name: '[1P-표준 보기]',
    },
    {
        id: 2164261622,
        label: '보기 > 원근감 격자 > 2점 투시 > [2P-표준 보기]',
        placement: 'MenuBar',
        name: '[2P-표준 보기]',
    },
    {
        id: 2164261623,
        label: '보기 > 원근감 격자 > 3점 투시 > [3P-표준 보기]',
        placement: 'MenuBar',
        name: '[3P-표준 보기]',
    },
    {
        id: 2164261626,
        label: '창 > 확장 프로그램 > 라이브러리',
        placement: 'MenuBar',
        name: '라이브러리',
    },
    {
        id: 2164261627,
        label: '창 > 버전 기록',
        placement: 'MenuBar',
        name: '버전 기록',
    },
    {
        id: 2164261628,
        label: '파일 > 버전 기록',
        placement: 'MenuBar',
        name: '버전 기록',
    },
    {
        id: 2164261629,
        label: '창 > 주석',
        placement: 'MenuBar',
        name: '주석',
    },
    {
        id: 'Adobe Scroll Tool',
        label: '손 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: '펜 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: '크기 조절 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: '회전 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: '반사 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: '기울이기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: '가위 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: '측정 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: '타일링 인쇄 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: '그룹 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: '직접 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: '선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: '돋보기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: '고정점 추가 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: '고정점 삭제 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: '고정점 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: '막대 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: '누적 막대 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: '선 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: '파이 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: '영역 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: '산포 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: '가로 막대 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: '가로 누적 막대 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: '레이더 그래프 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: '망 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: '문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: '영역 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: '패스 상의 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: '세로 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: '세로 영역 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: '패스 상의 세로 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: '문자 손질 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: '도형 구성 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: '라이브 페인트 통',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: '라이브 페인트 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: '원근감 격자 도구',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: '원근감 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: '블렌드 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: '분할 영역 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: '분할 영역 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: '올가미 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: '대지 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: '곡률 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: '퍼펫 뒤틀기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: '자동 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: '칼 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: '플레어 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: '자유 변형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: '선분 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: '호 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: '사각형 격자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: '극좌표 격자 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: '변형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: '돌리기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: '오목 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: '볼록 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: '조개 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: '수정화 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: '주름 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: '빠른 펜 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: '연필 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: '페인트 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: '물방울 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: '매끄럽게 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: '패스 지우개 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: '연결 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: '원형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: '다각형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: '별모양 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: '사각형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: '둥근 사각형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: '나선형 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: '심볼 분무기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: '심볼 이동기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: '심볼 분쇄기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: '심볼 크기 조절기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: '심볼 회전기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: '심볼 염색기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: '심볼 투명기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: '심볼 스타일기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: '그레이디언트 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: '치수 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: '패스상의 오브젝트',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: '회전 보기 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: '모양 변경 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: '선 폭 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: '지우개 도구',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: '스포이드 도구',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D 및 재질',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: '액션',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: '글리프',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: '브러쉬',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: '문자 스타일',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: '색상 안내',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: '병합 미리보기 ',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: '그레이디언트',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: '탭',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: '레이어',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: '특성',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: '단락 스타일',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: '속성',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: '분판 미리보기',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: '견본',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: '변수',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: '탭',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: '정렬',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: '모양',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: '대지',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: '주석',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS 속성(사용되지 않음)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: '라이브러리',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: '문자',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: '색상',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: '문서 정보',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: '자산 내보내기',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: '생성된 베리에이션',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: '작업 내역',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: '정보',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: '연결',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: '자동 선택',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: '목업',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: '그래픽 스타일',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: '내비게이터',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: '단락',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: '패스파인더',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: '패턴 옵션',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: '리플로우 뷰어',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: '재입력',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG 상호 작용',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: '획',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: '심볼',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: '변형',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: '투명도',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: '이미지 추적',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: '버전 기록',
        placement: 'Panel',
    },
];
